import axios from "axios";
import {
  ADD_TO_WATCHLIST,
  ALL_NOTIFICATIONS,
  ASK_QUESTION,
  AUTO_SUGGEST,
  BASE_URL,
  CLEAR_NOTIFICATION,
  DELETE_QUESTION,
  DETECT_DOMAIN,
  FAVOURITE_QA,
  GET_ANSWER_RATING,
  GET_IMAGE_ATTACHMENT_URL,
  GET_INLINE_IMAGE,
  GET_USER_BADGES,
  GET_USER_PROFILE_PIC,
  GET_WATCHLIST_USER,
  LOGIN_URL,
  LOGOUT_URL,
  NOTIFICATION_ACTION,
  OPEN_QUESTIONS,
  PROFILE_DATA,
  PROFILE_DATA_SEEKER_AWARDS,
  PROFILE_DATA_SEEKER_AWARDS_2,
  RATE_ANSWER,
  REQUEST_FOR_UPDATE,
  SEARCH_DATA_URL,
  SHARE_QUESTION,
  SEARCH_HISTORY,
  TAB_SEARCH_OPEN,
  UPDATE_QUESTIONTEXT,
  USER_EMAIL,
  USER_PASSWORD,
  FOLLOW_UP,
  GET_FILES,
  TAB_SEARCH,
  UPDATE_VIEW_COUNT,
  RECOMMEND_API,
  PAGES_API,
  FAVOURITE_API,
  KEYTAG_QA_API,
  KEY_TERM,
  UPDATE_PROFILE,
  SET_PROFILE_PICTURE,
  ACTIVITY_INFO,
  VALIDATE_QUESTION,
  URL_REDIRECTION_DATA_API,
  CURRENT_ROLE,
  EXPERT_OPEN_DATA,
  TAB_SEARCH_EXPERT_OPEN,
  FETCH_FORCE_REROUTE,
  CHANGE_DOMAIN,
  FORCE_REROUTE,
  EXPERT_DECLINE,
  ASK_CLARIFICATION,
  EXPERT_ANSWERED_API,
  EXPERT_TAB_SEARCH,
  CREATE_QA_PAIR,
  CURATION_STATUS_URL,
  ANOTHER_EXPERT_ANSWER,
  EXPERT_GET_DRAFT_DATA,
  EXPERT_SEND_DRAFT_DATA,
  EXPERT_UPDATE_ANSWER_API,
  EXPERT_ANSWER_QUESTION_API,
  EXPERT_RANK,
  VIEW_COUNT_STATS,
  SLA_COMPLIANCE,
  EXPERT_SCORE,
  AVG_RES_TIME,
  RECENT_RATINGS,
  BEST_RATINGS,
  WORST_RATINGS,
  BETTER_RATINGS,
  DOMAIN_BY_EXPERTS,
  GET_RATINGS_GROUPS,
  TOTAL_ANSWERED_TREND,
  EXPERT_SCORE_TREND,
  SLA_COMPLIANCE_TREND,
  RESPONSE_TIME_TREND,
  NEW_TRENDING_API,
  DELETE_ANSWER_RECORD_API,
  DECLINED_ANSWERS_API,
  EXPERT_OPEN_URL_REDIRECTION,
  FETCH_GDRIVE_FREQUENCY,
  FETCH_GDRIVE_DOCUMENTS,
  SOURCE_DOCS,
  CM_ATOMIZER_API,
  UPDATE_GDRIVE_ATTR,
  CM_JOBS_REVIEW_API,
  ADMIN_ROUTING_LEVELS_DATA,
  ADMIN_GEOLEVELS,
  GET_SEARCH_SUGGESTIONS,
  DELETE_SEARCH_SUGGESTION_RECORD,
  SEARCH_SUGGESTION_DETAIL,
  SEARCH_SUGGESTIONS_COUNT,
  Atomizer_Url,
  postPdf,
  scrapUrl,
  QA_Url,
  bloomFire,
  getBloomFire,
  postBloonfire,
  GET_WATCHLIST_USER_CM_ATOMIZER,
  GENERATE_TEXT,
  CM_EXPERT_RECORDS_COUNT,
  CM_EXPERT_RECORDS,
  CM_DETAILED_RECORDS,
  GET_ROUTING_HISTORY,
  JOB_API,
  DELETE_JOBS,
  VERIFIED_DOCS,
  AMEND_HEADERS,
  RFP_UPLOAD,
  RFP_DOC,
  GET_EXPERT_OVERVIEW_ANALYTICS,
  GET_EXPERTS_QCOUNTS,
  FETCH_CURATION_GRAPH_DATA,
  GET_AUDIT_LOGS,
  GET_DOMAINS_COUNT_GRAPHS,
  QUESTIONS_SEARCHED_COUNT,
  GET_DOMAINS_TIMELINE,
  GET_QUESTIONS_COUNT_BY_DAY,
  CM_OVERVIEW_TOTAL_QUESTION_COUNT,
  CM_OVERVIEW_USER_COUNT,
  seekerAnalytics,
  seekerBadges,
  seekeranalyticsque,
  expertanalytics,
  ExpertRankUrl,
  expertWiseCuration,
  GET_DOMAIN_WISE_COUNT,
  DOMAIN_SPECIFIC_GRAPH,
  currentGroup,
  GET_CRAWL_DOCS,
  GET_UPLOADED_CSV,
  EDIT_DATA_API,
  DELETE_DATA_API,
  GET_ANSWER_RATING_CM,
  Document_Tab,
  GET_FORCE_REROUTE_USER,
  TRANSFER_OWNERSHIP,
  REROUTE_RECORD,
  CM_ANSWER,
  CM_EXPEDITE,
  CM_DELETE_ANSWER,
  GET_WATCHLIST_USER_DEMOTED,
  ADMIN_PERMISSION,
  EXPERT_GENERATE_QA,
  ADMIN_USER_LIST,
  ADMIN_GET_GROUP_INFO,
  ADMIN_GET_ROUTING_LEVELS,
  ADMIN_GET_CURATION_ROUTING_VALUES,
  ADMIN_GET_CURATION_ROUTING_GROUP_WISE,
  ADMIN_UPDATE_ROUTING_LEVELS,
  ADMIN_UPDATE_GROUP_INFO,
  UPDATE_CURATION_ROUTING_POINT,
  REGENERATE_GENAI,
  USER_INACTIVE_TOGGLE,
  USER_INVITE_API,
  USER_REMOVE_FROM_GROUP,
  FETCH_ROLES,
  GET_USER_ATTR,
  GET_TIMEZONES,
  CONFIG_USER_ATTR,
  ADMIN_MANAGE_ROLE,
  CREATE_NEW_ROLE,
  DELETE_ROLE,
  EDIT_ROLE,
  CREATE_ROLE,
  Level_Action_Restriction,
  UpdateRestriction,
  getRegion,
  updatePermission,
  EmailIntegration,
  Email_Thread_QA,
  updateEmailQaPair,
  updateDeleteEmailQaPair,
  NEW_TRENDING_API_TWO,
  GET_KEY_TAGS,
  GET_AGENT_PLANNING,
  SAVE_AGENT_BRIEF,
  AGENT_BRIEF_HISTORY,
  GET_EXTERNAL_LINK_DATA,
  AGENT_BRIEF_DELETE,
  GET_TICKET_RECORDS,
  EXPERT_ANSWERED_COUNTS,
  TICKET_DETAIL,
  TICKET_UNREAD_READ,
  TICKET_UNREAD_READ_2,
  CATEGORY_EXPERT,
  TICKET_ASSIGN,
  // EXPERT_ANSWERED_COUNT,
  UI_BASE_URL,
  // EXPERT_ANSWERED_COUNTS,
  APP_STATUS,
  INCIDENT,
  CREATE_INCIDENT,
  EMAIL_ACTION,
  EXPERT_OPEN_QUESTION,
  
} from "./url";
import {
  setCookiesAfterLogin,
  isCookieExist,
  clearAllCookies,
  setCurrentGroupInLSWhileLogin,
  removeAllLS,
  handleError,
  convertEpochToTimestamp,
  getDataFromCookies,
  submitRatingSuccessToast,
  getDataFROMLS,
} from "../utils";
import { store } from "../Store/store";
import {
  addSearchedAnswerUuidInList,
  updateSearchData2,
  saveTopicUuid,
  advanceFilterModalToggle,
  searchInputValue,
  getSearchHistoryTotalCount,
  getAllNotifis,
  updateInlineImagesData,
  refreshTrendingData,
  getExpertProfilePics,
  openQuestionsCount,
  getAllActivityData,
  getAIGenerativeData,
  handleModal,
  handleResetState,
  handleLoadingSpinner,
  getCategories,
  handlePageRefresh,
  initailPage,
  getFrequencyList,
  handleDoubleInput,
  handleResetCategories,
  enableMutliple,
  handleResponse,
  getOpenDataCountExpert,
  loadingSearchSuggestionsKnowledgeQA,
  getSearchDataKnowledgeEntry,
  getRatingsDataInSearchSuggestions,
  getExpertAnalyticsDataInCmOverview,
  getCurationCountCMExpert,
  getExpertAnalyticsDataInCmOverviewForQuestions,
  isShowResultsCPR,
  getRawSearchData,
  ActionLevel,
  geoLevelRegionAction,
  updateKeytagsData,
  SearchExpDocData,
  getTrendingQA,
  getTagsInOpen,
  updateRatingBoolean,
  getTagsInExpertOpen,
  searchDataLoading,
  updateNewDeclinedLoader,
  getExpertRecordKeyTag,
  getSearchSuggestionKeytag,
  cmrUpdatePage,
  briefExternalSourceChange,
  briefInternalSourceChange,
  isUserLoggedInOrNot,
  getAgenticSourceData
} from "../Action/actions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { initialState } from "../Reducer/atomizerPageReducer";

export const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export const userLogin = (email, password, remember) => {
  if (isCookieExist("JSESSIONID")) return;
  store.dispatch(isUserLoggedInOrNot(true));
  let paramExist = localStorage.getItem("queryParams");
  let postLoginRedirect = localStorage.getItem("postLoginRedirect");
  var fd = new FormData();
  fd.append("email", email);
  fd.append("password", password);
  fd.append("remember-me", remember);
  fd.append("groupId", 0);
  instance
    .post(LOGIN_URL, fd)
    .then((res) => {
      if (res !== undefined) {
        setCurrentGroupInLSWhileLogin(res.data.data["groups"]);        
        res.data.data["groups"] = JSON.stringify(res.data.data["groups"]);
        let cookieObjKeys = Object.keys(res.data.data);
        let cookieObjValues = Object.values(res.data.data);
        setCookiesAfterLogin(cookieObjKeys, cookieObjValues);
          // store.dispatch(isUserLoggedInOrNot(false));
        fetchProfile(JSON.parse(res.data.data["groups"])).then(resp=>{
          let roleArr = resp.data.data.roles.map(role => role.roleName);
          if(roleArr.includes('CM')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("CM"));
          }else if(roleArr.includes('Expert')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
          }else if(roleArr.includes('Seeker')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
          }else if(roleArr.includes('Admin')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Admin"));
          }else{
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Emails"));
          }
          localStorage.removeItem("postLoginRedirect");
          if (postLoginRedirect) {
            window.location.href = `${UI_BASE_URL}${postLoginRedirect}`;
          } else {
            window.location.href = `${UI_BASE_URL}${paramExist===null?"":"?"+paramExist}`;
          }
        })
      }
    })
    .catch((err) => {
        store.dispatch(isUserLoggedInOrNot(false));
      toast.error(submitRatingSuccessToast(err.response.data.message), {
        position: toast.POSITION.TOP_RIGHT,
      });

    });
};
export const loginSuccess = () => {
  let paramExist = localStorage.getItem("queryParams");
  let postLoginRedirect = localStorage.getItem("postLoginRedirect");
  instance
    .get(LOGIN_URL)
    .then((res) => {
      if (res !== undefined) {
        setCurrentGroupInLSWhileLogin(res.data.data["groups"]);        
        res.data.data["groups"] = JSON.stringify(res.data.data["groups"]);
        let cookieObjKeys = Object.keys(res.data.data);
        let cookieObjValues = Object.values(res.data.data);
        setCookiesAfterLogin(cookieObjKeys, cookieObjValues);
        fetchProfile(JSON.parse(res.data.data["groups"])).then(resp=>{
          let roleArr = resp.data.data.roles.map(role => role.roleName);
          if(roleArr.includes('CM')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("CM"));
          }else if(roleArr.includes('Expert')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Expert"));
          }else if(roleArr.includes('Seeker')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Seeker"));
          }else if(roleArr.includes('Admin')){
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Admin"));
          }else{
            localStorage.setItem("ngStorage-currentRole", JSON.stringify("Emails"));
          }
          localStorage.removeItem("postLoginRedirect");
          if (postLoginRedirect) {
            window.location.href = `${UI_BASE_URL}${postLoginRedirect}`;
          } else {
            window.location.href = `${UI_BASE_URL}${paramExist===null?"":"?"+paramExist}`;
          }
        })
      }
    })
    .catch((err) => {
      handleError(err);
    });
};
export const userLogout = () => {
  instance
    .get(LOGOUT_URL)
    .then((res) => {
      let logoutLink = localStorage.getItem("logoutURL");
      clearAllCookies();
      removeAllLS();
      if (process.env.REACT_APP_MY_SSO) {
        if (logoutLink.length > 0) {
          window.location.href = logoutLink;
        } else {
          window.location.href = UI_BASE_URL+'/login';
        }
      } else {
        window.location.href = UI_BASE_URL+'/login';
      }
    })
    .catch((err) => {
      clearAllCookies();
      removeAllLS();
      window.location.href = UI_BASE_URL+'/login';
      handleError(err);
    });
};

export const fetchProfile = async(groupId) => {
  let response;
  await instance
    .get(PROFILE_DATA(groupId[0].id))
    .then((res) => { 
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
    return response;
};

export const fetchProfileForGroupSwitch = async (groupId) => {
  let resp = {};
  await instance
    .get(PROFILE_DATA(groupId))
    .then((res) => {
      if (res !== undefined) {
        resp = res;
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const fetchProfileForSeekerAwards = (groupId) => {
  instance
    .get(PROFILE_DATA_SEEKER_AWARDS(groupId[0].id))
    .then((res) => {
      window.location.reload();
    })
    .catch((err) => {
      handleError(err);
    });
};

export const fetchProfileForSeekerAwardsTwo = (dispatchFunc) => {

  instance
    .get(PROFILE_DATA_SEEKER_AWARDS_2)
    .then((res) => {
      if (res !== undefined) {
         if(res.data.data['agenticSources'] !== undefined && res.data.data['agenticSources']['Internal'] !== undefined){
          console.log("hello")
          store.dispatch(getAgenticSourceData(res.data.data.agenticSources))
          store.dispatch(briefInternalSourceChange(res.data.data['agenticSources']['Internal'].filter(obj => {
          if(obj.checked){
            return obj.value;
          }
        }).map(obj => obj.value)))
         }
    //  console.log("api",res.data.data.agenticSources)
        if(res.data.data['agenticSources'] !== undefined && res.data.data['agenticSources']['External'] !== undefined){
          store.dispatch(briefExternalSourceChange(res.data.data['agenticSources']['External'].filter(obj => {
          if(obj.checked){
            return obj.value;
          }
        }).map(obj => obj.value)))
        }
        // console.log("data",res.data.agenticSources)
       store.dispatch(getAgenticSourceData(res.data.data.agenticSources))
        dispatchFunc(res.data.data);
        getNotifications();
      }
    })
    .catch((err) => {
      handleError(err);
    });
};
export const fetchProfileForSeekerAwardsThree = async(dispatchFunc) => {
  
  let resp;
  await instance
    .get(PROFILE_DATA_SEEKER_AWARDS_2)
    .then((res) => {
      if (res !== undefined) {
        resp = res;
        store.dispatch(getAgenticSourceData(res.data.data.agenticSources))
        if(res.data.data['agenticSources'] !== undefined && res.data.data['agenticSources']['Internal'] !== undefined){
          store.dispatch(briefInternalSourceChange(res.data.data['agenticSources']['Internal'].filter(obj => {
          if(obj.checked){
            return obj.value;
          }
        }).map(obj => obj.value)))
         }
  // console.log("new api",res.data.data)
        if(res.data.data['agenticSources'] !== undefined && res.data.data['agenticSources']['External'] !== undefined){
          store.dispatch(briefExternalSourceChange(res.data.data['agenticSources']['External'].filter(obj => {
          if(obj.checked){
            return obj.value;
          }
        }).map(obj => obj.value)))
        }

        getNotifications();
      }
    })
    .catch((err) => {
      handleError(err);
    });
    return resp;
};
export const fetchAutosuggestionsData = async (text, dispatch) => {
  let payload = {
    question: text,
  };
  let response = [];
  await instance
    .post(AUTO_SUGGEST, payload)
    .then((res) => {
      if (res !== undefined) {
        dispatch(res.data.data);
        response = res.data.data;
        return res.data.data;
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const fetchAutosuggestions = async (text) => {
  let payload = {
    question: text,
  };
  let response = [];

  await instance
    .post(AUTO_SUGGEST, payload)
    .then((res) => {
      if (res !== undefined) {
        response = res.data.data;
        return res.data.data;
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
const manipulateVideodata = (data) => {
  for (let i = 0; i < data.length; ++i) {
    data[i]["suggestions"] = [];
    for (let j = 0; j < data.length; ++j) {
      if (data[i].docType === "Video" && data[j].docType === "Video") {
        if (data[i].docName === data[j].docName) {
          // data.splice(0,j);
          if (data[i]["suggestions"].length < 5) {
            data[i]["suggestions"].push({ ...data[j] });
          }
        }
      }
    }
  }

  let filteredArr = data.filter(function (a) {
    if (a.docType !== "Video") {
      this[a.docName] = true;
      return true;
    } else {
      if (!this[a.docName]) {
        this[a.docName] = true;
        return true;
      }
    }
  }, Object.create(null));
  return filteredArr;
}
let formatVideoDocData = (data) => {
  // for (let i = 0; i < data.length; ++i) {
  //   data[i]["suggestions"] = [];
  //   for (let j = 0; j < data.length; ++j) {
  //     if (data[i].docType === "Video" && data[j].docType === "Video") {
  //       if (data[i].docName === data[j].docName) {
  //         // data.splice(0,j);
  //         if (data[i]["suggestions"].length < 5) {
  //           data[i]["suggestions"].push({ ...data[j] });
  //         }
  //       }
  //     }
  //   }
  // }
  let dataTrue = manipulateVideodata(data.filter(daa => daa.confidence));
  let dataFalse = manipulateVideodata(data.filter(daa => !daa.confidence));
  // console.log(data);
  return [...dataTrue, ...dataFalse];
};

export const fetchSearchResult = (
  payload,
  dispatch,
  profilePicDispatch,
  ratingDispatch
) => {
  let userUuids = [];
  let answerUuids = [];
  let docIds = [];
  let questionUuidsss = [];
  let allInlineImages = [];
  if (payload.domains.length > 0) {
    payload.domains = payload.domains.map((obj) => obj.name);
  }
  payload.unified = true;
  // console.log('payload', payload)
  instance
    .post(SEARCH_DATA_URL, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (
        res.data.data[0].searchData &&
        res.data.data[0].searchData.length > 0
      ) {
        store.dispatch(
          getAIGenerativeData(res.data.data[0].searchData[0].summaryUuidStr)
        );
      } else {
        store.dispatch(getAIGenerativeData(""));
      }
      if (res.data.data[0].searchData && res.data.data[0].searchData.length > 0) {
        res.data.data[0].searchData.filter((obj) => {
          if (obj.docType === 'expertqa') {
            questionUuidsss.push(obj.origQuestionUuid);
          }
          if (obj.docType === 'Thread' || obj.docType === 'urlcrawl') {
            if (obj.source !== undefined && obj.source !== '') {
              obj['newDocType'] = obj.source;
            } else {
              obj['newDocType'] = obj.docType;
            }
          } else {
            obj['newDocType'] = obj.docType;
          }
        })
      }
      // console.log(res.data.data[0].searchData);
      res.data.data[0].searchData = formatVideoDocData(
        res.data.data[0].searchData
      );
      store.dispatch(loadingSearchSuggestionsKnowledgeQA(false));
      store.dispatch(saveTopicUuid(res.data.data[0].topicUuid));
      let bestTag = false;
      let similartag = false;
      res.data.data[0].searchData.filter((obj) => {
        obj.showSimilarTag = false;
        obj.showBestTag = false;
        if (obj.confidence && !bestTag) {
          bestTag = true;
          obj.showBestTag = true;
        }
        if (!obj.confidence && !similartag) {
          similartag = true;
          obj.showSimilarTag = true;
        }
      });
      store.dispatch(isShowResultsCPR(true));
      store.dispatch(getRawSearchData(res.data.data[0].searchData));
      dispatch(res.data.data[0].searchData);
      if (res.data.data[0].searchData.length > 0) {
        res.data.data[0].searchData.filter((obj) => {
          obj.questionUuidCopy = obj.questionUuid;
          obj.answers.filter(async (answer) => {
            answer.expertUuid = answer.expert.userUuidStr;
            answer.answerCopy = answer.answerText;
            if (
              answer.inlineImages !== null &&
              answer.inlineImages.length > 0
            ) {
              allInlineImages = allInlineImages.concat(answer.inlineImages);
              instance
                .post(GET_FILES, answer.inlineImages)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  if (res1.data.success) {
                    for (let i = 0; i < answer.inlineImages.length; ++i) {
                      if (answer.inlineImages[i].includes(".png")) {
                        let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
                          }|]`;
                        let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                          }></img>`;
                        answer.answerText = answer.answerText.replaceAll(
                          replacedContent,
                          imgTag
                        );
                        // console.log("png image",   answer.answerText)
                        dispatch(res.data.data[0].searchData);
                      } else {
                        let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                          }></img>`;

                        let replacedContent = answer.inlineImages[i];
                        answer.answerText = answer.answerText.replace(
                          replacedContent,
                          imgTag
                        );
                        // console.log("Search image", answer.answerText)
                        dispatch(res.data.data[0].searchData);
                      }
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
          if (obj.docType === "expertqa") {
            getSearchDataKnowledgeEntry(obj);
            obj.answers.filter((answer) => {
              answer.isHelpful = false;
              answer.isReject = false;
              if (
                answer.expert.userUuidStr != getDataFromCookies("userUuid") &&
                answer.seekerCurationVisibility &&
                answer.curationCategory == "1" &&
                answer.curationStatus == "pending"
              ) {
                obj.isShowUpdateRequestWarning = true;
              }
              answerUuids.push(answer.origAnswerUuid);
              userUuids.push(answer.expertImage.uuid);
              answer.attachmentURL = [];
              answer.attachmentVideo = [];
              answer.attachments.filter((attachment) => {
                if (
                  attachment.name.includes(".jpeg") ||
                  attachment.name.includes(".jpg") ||
                  attachment.name.includes(".png") ||
                  attachment.name.includes(".JPEG") ||
                  attachment.name.includes(".JPG") ||
                  attachment.name.includes(".PNG")
                ) {

                  let payload = { name: attachment.name };
                  // console.log('payload1', payload)
                  instance
                    .post(GET_IMAGE_ATTACHMENT_URL, payload)
                    .then((res1) => {
                      if (res1 === undefined) {
                        return;
                      }
                      answer.attachmentURL.push(res1.data.data);
                      dispatch(res.data.data[0].searchData);
                    })
                    .catch((err) => {
                      handleError(err);
                    });
                }
                if (
                  attachment.name.includes(".mp4") ||
                  attachment.name.includes(".mov")
                ) {
                  answer.attachmentVideo.push(attachment);
                }
              });
            });
          }

          if (obj.docType !== "expertqa") {
            obj.answers.filter((answer) => {
              docIds.push(answer.docId);
              answer.isHelpful = false;
              answer.isReject = false;
              if (obj.docType === "Pdf" || obj.docType === "Image") {
                answer.attachmentURL = [];
                answer.attachments.filter((attachment) => {
                  if (
                    attachment.name.includes(".jpeg") ||
                    attachment.name.includes(".jpg") ||
                    attachment.name.includes(".png") ||
                    attachment.name.includes(".JPEG") ||
                    attachment.name.includes(".JPG") ||
                    attachment.name.includes(".PNG")
                  ) {
                    let payload = { name: attachment.name };
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        answer.attachmentURL.push(res1.data.data);
                        dispatch(res.data.data[0].searchData);
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
              }
              if (obj.docType === "Thread") {
                if (obj.threadType === "REUSABLE_THREAD_QA") {
                  answer.threadAttachments.unshift([]);
                  answer.threadAttachments.unshift([]);
                }
                answer.threadAttachmentsURL = [];
                answer.threadAttachments.filter((att1) => {
                  if (att1.length === 0) {
                    answer.threadAttachmentsURL.push([]);
                  } else {
                    let asdffgh = [];
                    att1.filter((att2) => {
                      if (
                        att2.name.includes(".jpeg") ||
                        att2.name.includes(".jpg") ||
                        att2.name.includes(".png") ||
                        att2.name.includes(".JPEG") ||
                        att2.name.includes(".JPG") ||
                        att2.name.includes(".PNG")
                      ) {
                        let payload = { name: att2.name };
                        console.log('payload 3', payload)
                        instance
                          .post(GET_IMAGE_ATTACHMENT_URL, payload)
                          .then((res1) => {
                            if (res1 === undefined) {
                              return;
                            }
                            asdffgh.push(res1.data.data);
                            dispatch(res.data.data[0].searchData);
                          })
                          .catch((err) => {
                            handleError(err);
                          });
                      }
                    });
                    answer.threadAttachmentsURL.push(asdffgh);
                  }
                });
              }

              if (obj.docType === "Video" && obj.docName.length > 0) {
                obj.videoAttachmentURL = [];
                // let payload = {
                //   name: obj.docName,
                // };
                let payload = [];
                payload.push(obj.docName)
                // add check here
                instance
                  .post(GET_FILES, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    console.log("video response value", res.data.data[0].searchData)
                    obj.videoAttachmentURL.push(res1.data.data[obj.docName]);
                    dispatch(res.data.data[0].searchData);
                  })
                  .catch((err) => {
                    handleError(err);
                  });
                obj.suggestions.filter((suggestion) => {
                  suggestion.videoAttachmentURL = obj.videoAttachmentURL;
                  suggestion.suggestions = obj.suggestions;
                  docIds.push(suggestion.answers[0].docId);
                });
              }
            });
          }
        });
        getFiles([...new Set(allInlineImages)]);
        getKeyTag(questionUuidsss);
        getAnswerRatings(answerUuids, docIds, ratingDispatch);
        getExpertsProfilePics(userUuids, profilePicDispatch);
        updateViewCountTwo({ answerIds: answerUuids, docIds: docIds });
        store.dispatch(SearchExpDocData(
          {
            exp: res.data.data[0].searchData.filter(ob => { if (ob.docType === "expertqa") { return ob } }),
            doc: res.data.data[0].searchData.filter(ob => { if (ob.docType !== "expertqa") { return ob } })
          }
        ));
      }
    })
    .catch((err) => {
      handleError(err);
    });
};

export const getFiles = (files) => {
  // console.log("files", files)
  var response
  if (files && files.length > 0) {
    instance
      .post(GET_FILES, files)
      .then((res1) => {
        if (res1 === undefined) {
          return;
        }
        if (res1.data.success) {
          response = res1.data.data;
          store.dispatch(updateInlineImagesData(files, res1.data.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return response;
};

export const getFiles1 = (files, setLink) => {
  // console.log("files", files)
  var response
  if (files && files.length > 0) {
    instance
      .post(GET_FILES, files)
      .then((res1) => {
        if (res1 === undefined) {
          return;
        }
        if (res1.data.success) {
          // console.log("new", res1.data.data[files[0]])
          // response=res1.data.data;
          setLink(res1.data.data[files[0]])
          return res1.data.data
          // store.dispatch(updateInlineImagesData(files, res1.data.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // console.log("file repone", response)
  return response;
};
export const fetchAttachmentURL = async (payload) => {
  let resp = {};
  console.log("vidoe payload line nuber 740", payload)
  await instance
    .post(GET_IMAGE_ATTACHMENT_URL, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
      return res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getUserprofilePic = async () => {
  let data = {};
  await instance
    .get(GET_USER_PROFILE_PIC)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      data = res;
      return res;
    })
    .catch((err) => {
      handleError(err);
    });
  return data;
};

export const markUnmarkFavourite = async (questionUuid) => {
  let response;
  await instance
    .post(FAVOURITE_QA(questionUuid))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
      return res;
    })
    .catch((err) => {
      response = err;
      handleError(err);
    });
  return response;
};

export const getExpertsProfilePics = (userUuids, dispatch) => {
  // console.log('pushed', userUuids)
  let unique = [...new Set(userUuids)];
  // console.log("unique", unique.toString())
  instance
    .get(`${GET_USER_PROFILE_PIC}?userUuids=${unique.toString()}`)
    .then((res) => {
      // console.log('response', res)
      if (res === undefined) {
        return;
      }
      // console.log('profile',res.data.data)
      store.dispatch(getExpertProfilePics(res.data.data));
    })
    .catch((err) => {
      handleError(err);
    });
};

export const getAnswerRatings = (answerUuid, docId, dispatch) => {
  // console.log("getting answer",answerUuid);
  store.dispatch(updateRatingBoolean(true))
  // console.log("getting docid",docId)
  store.dispatch(
    addSearchedAnswerUuidInList([...new Set(answerUuid)], [...new Set(docId)])
  );
  instance
    .get(GET_ANSWER_RATING(answerUuid, docId))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if(res.data.success) {
        // console.log("success",res.data.success)
        store.dispatch(updateRatingBoolean(false));}
      // console.log("api response",res)
      store.dispatch(updateRatingBoolean(false));
      store.dispatch(updateSearchData2(res.data.data));
      store.dispatch(getRatingsDataInSearchSuggestions(res.data.data));
    })
    .catch((err) => {
      handleError(err);
    });
};

export const rateAnswer = (payload, dispatch, ratings) => {
  const submitRatingSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  instance
    .post(RATE_ANSWER, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (res.data.success) {
        ratings[
          payload.answerUuid === null ? payload.docId : payload.answerUuid
        ] = res.data.data;
        dispatch(ratings);
      }
      toast.success(submitRatingSuccessToast(res.data.message), {
        position: toast.POSITION.TOP_RIGHT,
      });
    })
    .catch((err) => {
      handleError(err);
    });
};

export const detectDomain = async (payload) => {
  let response;
  await instance
    .post(DETECT_DOMAIN, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchUsers = async (query, isInternal, role) => {
  let response;
  await instance
    .get(GET_WATCHLIST_USER(query, isInternal, role))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchUsers_CM_Atomizer = async (query, role) => {
  let response;
  await instance
    .get(GET_WATCHLIST_USER_CM_ATOMIZER(query, role))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const submitQuestion = async (payload) => {
  let response;
  store.dispatch(advanceFilterModalToggle({ bool: false, value: "" }));
  await instance
    .post(ASK_QUESTION, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      store.dispatch(searchInputValue(""));
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const requestForUpdate = async (payload) => {
  let response;
  await instance
    .post(REQUEST_FOR_UPDATE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const shareQuestion = async (payload) => {
  let response;
  await instance.post(SHARE_QUESTION, payload).then((res) => {
    if (res === undefined) {
      return;
    }
    response = res;
  });
  return response;
};

export const searchHistoryData = async (pageNo, sortOrder) => {
  let response;
  function convertEpochToTimestamp2(epoch) {
    var d = new Date(epoch);
    let arr = d.toLocaleDateString();
    return arr;
  }
  await instance
    .get(SEARCH_HISTORY(pageNo, sortOrder))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      store.dispatch(getSearchHistoryTotalCount(res.data.count));
      var newArr = [];
      let arr2 = res.data.data.filter((obj) => {
        obj.timestamp = convertEpochToTimestamp(obj.timestamp);
        obj.date = convertEpochToTimestamp2(obj.timestamp);
        return obj;
      });
      let uniqueDates = [
        ...new Set(
          arr2.map((obj) => {
            return obj.date;
          })
        ),
      ];
      uniqueDates.filter((obj) => {
        let filterDates = arr2.filter((obj2) => {
          if (obj2.date == obj) {
            return obj2;
          }
        });
        newArr.push({
          time: new Date(filterDates[0].timestamp).toDateString(),
          dat: filterDates,
        });
      });
      response = newArr;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getNotifications = () => {
  instance
    .get(ALL_NOTIFICATIONS)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (res.data.success === true) {
        let data = JSON.parse(res.data.data.uuid);
        let filteredData = data.filter((notif) => {
          notif.notification = JSON.parse(notif.notification);
          notif.data = JSON.parse(notif.data);
          if (
            notif.data.msgType === "expert_answered" &&
            CURRENT_ROLE === "Seeker"
          ) {
            notif.header = "You got answer!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "request_for_review" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Request for review!";
            notif.icon = "fa fa-comments";
            // console.log("request for review", notif.data);
            return notif;
          }
          if (
            notif.data.msgType === "rfp_file_processed" &&
            CURRENT_ROLE === "Seeker"
          ) {
            notif.header = "Multi-Question File Processed!";
            notif.data.extraInfo = "Ready for download!";
            notif.notification.title = "";
            notif.icon = "fa fa-download";
            return notif;
          }
          if (notif.data.msgType === "question updated") {
            notif.header = "Your Answer got updated!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (notif.data.msgType === "another_expert_answered") {
            notif.header = "You got answer!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "watchlist_user" &&
            CURRENT_ROLE === "Seeker"
          ) {
            notif.header = "You got answer!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (notif.data.msgType === "question_shared") {
            notif.header = "Shared a question!";
            notif.icon = "fa fa-share-alt";
            return notif;
          }
          if (
            notif.data.msgType === "expert_clarify" &&
            CURRENT_ROLE === "Seeker"
          ) {
            notif.header = "Expert asked for a clarification!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "question_expired" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Expert asked for a clarification!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "question_rerouted" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Expert asked for a clarification!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "new_question" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Expert asked for a clarification!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "seeker_clarified" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Your question got clarified!";
            notif.icon = "fa fa-comments";
            return notif;
          }
          if (
            notif.data.msgType === "seeker_rated" &&
            CURRENT_ROLE === "Expert"
          ) {
            notif.header = "Your answer got rated!";
            notif.icon = "fa fa-star";
            return notif;
          }
        });
        store.dispatch(getAllNotifis(filteredData));
      }
    })
    .catch((err) => {
      handleError(err);
    });
};

export const clearNotifications = () => {
  let payload = {
    msgValue: 2,
  };
  instance
    .post(CLEAR_NOTIFICATION, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      return res;
    })
    .catch((err) => {
      handleError(err);
    });
};

export const notificationAction = async (payload) => {
  let response;
  await instance
    .post(NOTIFICATION_ACTION, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchInlineImages = async (answerUuidStr) => {
  let response;
  await instance
    .get(GET_INLINE_IMAGE(answerUuidStr))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getTrendingdataV2 = async (
  pageNo,
  sortFilter,
  sortOrder,
  domains,
  expertindex,
  threadindex,
  searchindex,
  viewindex,
  acceptedindex
) => {
  let response;
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.map((ob) => ob.name).toString();
  }
  await instance
    .get(
      NEW_TRENDING_API(
        pageNo,
        sortFilter,
        sortOrder,
        domains,
        expertindex,
        threadindex,
        searchindex,
        viewindex,
        acceptedindex
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.records.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            if (qa.status === "accepted") {
              answer.threadAttachments.unshift([]);
              answer.threadAttachments.unshift([]);
            }
            if (qa.status !== "accepted") {
              answer.threadAttachments.filter((arr2) => {
                if (arr2.length > 0) {
                  arr2.filter((obj) => {
                    answer.attachments.push(obj);
                  });
                }
              });
            }
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          if (answer.expertUuid !== undefined) {
            userUuid.push(answer.expertUuid);
          }
          answer.answerCopy = answer.answer;
          if (answer.docId === undefined) {
            if (answer.answerUuid !== undefined) {
              answerUuids.push(
                answer.originalAnswerUuid !== undefined
                  ? answer.originalAnswerUuid
                  : answer.answerUuid
              );
            }
          } else {
            docIds.push(answer.docId);
          }
          answer.attachmentURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachmentsURL = [];
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                      // store.dispatch(getTrendingQA(res.data.data));
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, docIds, undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};



export const getTrendingData = async (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  status,
  curationCategory = null,
  isTransferred = null,
  curationStatus = null
) => {
  // console.log("calling the api")
  let response;
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.map((ob) => ob.name).toString();
  }
  // console.log("domains",domains)
  await instance
    .get(
      curationCategory === null
        ? PAGES_API(pageNo, sortFilter, sortOrder, sortChange, domains, status)
        : EXPERT_ANSWERED_API(
          pageNo,
          sortFilter,
          sortOrder,
          sortChange,
          domains,
          status,
          curationCategory,
          isTransferred,
          curationStatus
        )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            answer.threadAttachments.unshift([]);
            answer.threadAttachments.unshift([]);
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          userUuid.push(answer.expertUuid);
          answer.answerCopy = answer.answer;
          if (answer.docId === undefined) {
            answerUuids.push(
              answer.originalAnswerUuid !== undefined
                ? answer.originalAnswerUuid
                : answer.answerUuid
            );
          } else {
            docIds.push(answer.docId);
          }
          answer.attachmentURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachmentsURL = [];
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                      // store.dispatch(getTrendingQA(res.data.data));
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // answer.attachments.filter((attch) => {
          //   if (
          //     attch.name.includes(".png") ||
          //     attch.name.includes(".jpg") ||
          //     attch.name.includes(".jpeg") ||
          //     attch.name.includes(".JPEG") ||
          //     attch.name.includes(".JPG") ||
          //     attch.name.includes(".PNG")
          //   ) {
          //     let payload = { name: attch.name };
          //     instance
          //       .post(GET_IMAGE_ATTACHMENT_URL, payload)
          //       .then((res1) => {
          //         if (res1 === undefined) {
          //           return;
          //         }
          //         answer.attachmentURL.push(res1.data.data);
          //         store.dispatch(refreshTrendingData("refreshed"));
          //       })
          //       .catch((err) => {
          //         handleError(err);
          //       });
          //   }
          // });

          answer.attachments.filter((attch) => {
            if (
              attch.name.toLowerCase().includes(".png") ||
              attch.name.toLowerCase().includes(".jpg") ||
              attch.name.toLowerCase().includes(".jpeg") ||
              attch.name.toLowerCase().includes(".JPEG") ||
              attch.name.toLowerCase().includes(".JPG") ||
              attch.name.toLowerCase().includes(".PNG")
            ) {
              let payload = { name: attch.name };
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
            if (
              attch.name.toLowerCase().includes(".mov") ||
              attch.name.toLowerCase().includes(".mp4") ||
              attch.name.toLowerCase().includes(".mkv")
            ) {
              let payload = [attch.name];
              instance
                .post(GET_FILES, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  attch.objectUrl = res1.data.data[attch.name];
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
            // console.log(answer.attachments)
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, docIds, undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
// export const EXPERT_ANSWERED_COUNT = (pageNo, status) => {
//   const url = `expert/group/${currentGroup}/expertrecordsbypage?page=${pageNo}&status=${status}&count=true`;
//   return axios.get(url); // Make the POST request and return the Promise
// };
export const getAnsweredCount = async (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,

) => {
  // console.log("calling the api")
  let response;
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  let userUuid = [];
  // if (domains.length > 0) {
  //   domains = domains.map((ob) => ob.name).toString();
  // }
  // console.log("domains",domains)
  await instance
    .get(
      EXPERT_ANSWERED_COUNTS
      // EXPERT_ANSWERED_COUNT(
      //     pageNo,
      //     sortFilter,
      //     sortOrder,
      //     sortChange,
   
      //   )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getAnswerRatingsInNotificationAction = async (
  answerUuids,
  docIds
) => {
  let response;
  await instance
    .get(GET_ANSWER_RATING(answerUuids, docIds))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const editQuestionText = async (payload) => {
  let response;
  await instance
    .post(UPDATE_QUESTIONTEXT, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getTabSearchData = async (
  pageNo,
  status,
  sortFilter,
  question,
  sortOrder,
  sortChange,
  domains,
  category = null,
  curationCategory = null,
  isTransferred = null,
  curationStatus = null
) => {
  let response;
  let answerUuids = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.map((ob) => ob.name).toString();
  }
  // `/question/group/${currentGroup}/tab-search?category=${category}&solarIndex=0&question=${question}&page=${page}&status=${status}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
  //   domainFilter
  // )}`
  // console.log("domains",domains)
  let paylaod = {
    category: category,
    solarIndex: 0,
    question: question,
    page: pageNo,
    status: status,
    sortFilter: sortFilter,
    sortOrder: sortOrder,
    sortChange: sortChange,
    domain: encodeURIComponent(domains),
  };
  let paylaodExpert = {
    category: category,
    solarIndex: 0,
    question: question,
    page: pageNo,
    status: status,
    sortFilter: sortFilter,
    sortOrder: sortOrder,
    sortChange: sortChange,
    domain: encodeURIComponent(domains),
    curationcategory: curationCategory,
    transferred: isTransferred,
    curationstatus: curationStatus,
    ownRecords: true,
  };
  await instance
    .post(
      curationCategory === null ? TAB_SEARCH : EXPERT_TAB_SEARCH,
      curationCategory === null ? paylaod : paylaodExpert
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            answer.threadAttachments.unshift([]);
            answer.threadAttachments.unshift([]);
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          userUuid.push(answer.expertUuid);
          answer.answerCopy = answer.answer;
          answerUuids.push(
            answer.originalAnswerUuid !== undefined
              ? answer.originalAnswerUuid
              : answer.answerUuid
          );
          answer.attachmentURL = [];
          answer.threadAttachmentsURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, [], undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const seekerFollowUp = async (payload) => {
  let response;
  await instance
    .post(FOLLOW_UP, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getUserBadgesSeeker = async () => {
  let response;
  await instance
    .get(GET_USER_BADGES)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getInlineImage = async (files) => {
  let resp;
  await instance
    .post(GET_FILES, files)
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      resp = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const fetchOpenQuestions = async (
  pageNo,
  status,
  sortFilter,
  sortOrd,
  sortChange,
  domainFil
) => {
  if (domainFil.length === 0) {
    domainFil = "";
  } else {
    domainFil = domainFil.map((v) => {
      return v.value;
    });
  }
  let response;
  await instance
    .get(
      OPEN_QUESTIONS(pageNo, status, sortFilter, sortOrd, sortChange, domainFil)
    )
    .then((res) => {
      store.dispatch(openQuestionsCount(res.data.count));
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const deleteQuestionOpen = async (payload) => {
  let response;
  await fetch(BASE_URL + DELETE_QUESTION, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Cookie: document.cookie,
    },
    body: payload,
  })
    .then((res) => res.json())
    .then((res1) => {
      if (res1.status && res1.status === 401) {
        userLogout();
      }
      response = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const OpenTabSearchQuestions = async (
  page,
  status,
  sortFilter,
  question,
  sortOrder,
  sortChange,
  domainFilter
) => {
  domainFilter = domainFilter.map((v) => {
    return v.value;
  });
  let response;
  let paylaod = {
    category: null,
    solarIndex: 0,
    question: question,
    page: page,
    status: status,
    sortFilter: sortFilter,
    sortOrder: sortOrder,
    sortChange: sortChange,
    domain: encodeURIComponent(domainFilter),
  };
  await instance
    .post(TAB_SEARCH_OPEN, paylaod)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const addToWatchlistOpen = async (payload) => {
  let response;
  await instance
    .post(ADD_TO_WATCHLIST, payload)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const updateViewCount = (payload, dispatch) => {
  // if(ids.length>0){
  instance
    .put(UPDATE_VIEW_COUNT, payload)
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      dispatch([]);
    })
    .catch((err) => {
      handleError(err);
    });
  // }
};
export const updateViewCountTwo = (payload) => {
  // if(ids.length>0){
  instance
    .put(UPDATE_VIEW_COUNT, payload)
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      // dispatch([]);
    })
    .catch((err) => {
      handleError(err);
    });
  // }
};

export const rateRecommandedAnswer = async (payload) => {
  let resp;
  await instance
    .post(RATE_ANSWER, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const recommendQuestionData = async (payload) => {
  let resp;
  await instance
    .post(RECOMMEND_API, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getFavouriteData = async (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  category,
  status
) => {
  let response;
  let answerUuids = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.map((ob) => ob.name).toString();
  }
  await instance
    .get(
      FAVOURITE_API(
        pageNo,
        sortFilter,
        sortOrder,
        sortChange,
        domains,
        category,
        status
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            answer.threadAttachments.unshift([]);
            answer.threadAttachments.unshift([]);
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          userUuid.push(answer.expertUuid);
          answer.answerCopy = answer.answer;
          answerUuids.push(
            answer.originalAnswerUuid !== undefined
              ? answer.originalAnswerUuid
              : answer.answerUuid
          );
          answer.attachmentURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachmentsURL = [];
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
            if (
              attch.name.toLowerCase().includes(".mov") ||
              attch.name.toLowerCase().includes(".mp4") ||
              attch.name.toLowerCase().includes(".mkv")
            ) {
              let payload = [attch.name];
              instance
                .post(GET_FILES, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  attch.objectUrl = res1.data.data[attch.name];
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, [], undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchKeyTagData = async (
  pageNo,
  tagStr,
  queryType,
  searchQuery
) => {
  let resp;
  let answerUuids = [];
  let allInlineImages = [];
  let userUuid = [];
  await instance
    .get(KEYTAG_QA_API(pageNo, tagStr, queryType, searchQuery))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (queryType === "expert") {
        res.data.data.tagsQaData.filter((qa) => {
          qa.answersList.filter((answer) => {
            if (
              answer.expertUuid != getDataFromCookies("userUuid") &&
              answer.seekerCurationVisibility &&
              answer.curationCategory == "1" &&
              answer.curationStatus == "pending"
            ) {
              qa.isShowUpdateRequestWarning = true;
            }
            userUuid.push(answer.expertUuid);
            answer.answerCopy = answer.answer;
            answerUuids.push(
              answer.originalAnswerUuid !== undefined
                ? answer.originalAnswerUuid
                : answer.answerUuid
            );
            answer.attachmentURL = [];
            if (answer.answer.includes("vizsep")) {
              answer.threadAttachmentsURL = [];
              answer.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  answer.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png") ||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      instance
                        .post(GET_IMAGE_ATTACHMENT_URL, payload)
                        .then((res1) => {
                          if (res1 === undefined) {
                            return;
                          }
                          asdffgh.push(res1.data.data);
                          store.dispatch(refreshTrendingData("refreshed"));
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  answer.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            if (
              answer.inlineImages !== null &&
              answer.inlineImages.length > 0
            ) {
              allInlineImages = allInlineImages.concat(answer.inlineImages);
              instance
                .post(GET_FILES, answer.inlineImages)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  if (res1.data.success) {
                    for (let i = 0; i < answer.inlineImages.length; ++i) {
                      if (answer.inlineImages[i].includes(".png")) {
                      } else {
                        let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                          }></img>`;

                        let replacedContent = answer.inlineImages[i];
                        answer.answer = answer.answer.replace(
                          replacedContent,
                          imgTag
                        );
                      }
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            answer.attachments.filter((attch) => {
              if (
                attch.name.includes(".png") ||
                attch.name.includes(".jpg") ||
                attch.name.includes(".jpeg") ||
                attch.name.includes(".JPEG") ||
                attch.name.includes(".JPG") ||
                attch.name.includes(".PNG")
              ) {
                let payload = { name: attch.name };
                // console.log('payload 15', payload)
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    answer.attachmentURL.push(res1.data.data);
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
            });
          });
        });
        getFiles([...new Set(allInlineImages)]);
        getAnswerRatings(answerUuids, [], undefined);
        getExpertsProfilePics(userUuid, undefined);
        resp = res;
      } else {
        resp = res;
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getKeyTermData = async (pageNo, domains, tag, words) => {
  if (domains.length === 0) {
    domains = "";
  }
  if (domains && domains.name) {
    if (domains.name === "All") {
      domains = "";
    } else {
      domains = domains.name;
    }
  }
  let resp;
  await instance
    .get(KEY_TERM(pageNo, domains, tag, words))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};
export const updateSeekerProfileData = async (payload) => {
  let resp;
  await instance
    .post(UPDATE_PROFILE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const setProfilePicture = async (payload) => {
  let resp;
  var fd = new FormData();
  fd.append("file", payload);
  await instance
    .post(SET_PROFILE_PICTURE, fd)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getActivityInfo = async () => {
  if (CURRENT_ROLE === "Seeker") {
    let resp;
    await instance
      .get(ACTIVITY_INFO)
      .then((res) => {
        let newData = Object.entries(res.data.data);
        store.dispatch(getAllActivityData(newData));
      })
      .catch((err) => {
        handleError(err);
      });
    return resp;
  }
};

export const validateQuestions = async (payload) => {
  let resp;
  await instance
    .get(VALIDATE_QUESTION(payload.type, payload.quesUuid))
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const URLDerectionData = async (id) => {
  let resp;
  await instance
    .get(URL_REDIRECTION_DATA_API(id))
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const URLOpenDerectionData = async (id) => {
  let resp;
  await instance
    .get(EXPERT_OPEN_URL_REDIRECTION(id))
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};
export const updateCurationStatus = async (payload) => {
  let resp;
  await instance
    .post(CURATION_STATUS_URL, payload)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      // resp = err;
      handleError(err);
    });
  return resp;
};

//API calls for Expert start//
export const getExpertOpenPageData = async (
  pageNo,
  sortFilter,
  sortOrd,
  sortChange,
  domainFil,
  ownRecords
) => {
  if (domainFil.length === 0) {
    domainFil = "";
  } else {
    domainFil = domainFil.map((v) => {
      return v.value;
    });
  }
  let response;
  await instance
    .get(
      EXPERT_OPEN_DATA(
        pageNo,
        sortFilter,
        sortOrd,
        sortChange,
        domainFil,
        ownRecords
      )
    )
    .then((res) => {
      store.dispatch(getOpenDataCountExpert(res.data.count));
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const ExpertOpenTabSearchQuestions = async (payload) => {
  // domainFilter = domainFilter.map(v=>{
  //   return v.value;
  // })
  let response;
  await instance
    .post(TAB_SEARCH_EXPERT_OPEN, payload)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const FetchForceReroute = async (questionId, domainId) => {
  let response;
  await instance
    .get(FETCH_FORCE_REROUTE(questionId, domainId))
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const changeDomainExpert = async (payload) => {
  let response;
  await instance
    .post(CHANGE_DOMAIN, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const CreateQAPair = async (payload) => {
  let response;
  await instance
    .post(CREATE_QA_PAIR, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const ForceReroute = async (payload) => {
  let response;
  await instance
    .post(FORCE_REROUTE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
/* APIs for my stats start */
export const getExpertRankData = async () => {
  let resp;
  await instance
    .get(EXPERT_RANK)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getViewCountStats = async () => {
  let resp;
  await instance
    .get(VIEW_COUNT_STATS)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getSLAComplianceData = async () => {
  let resp;
  await instance
    .get(SLA_COMPLIANCE)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getExpertScore = async () => {
  let resp;
  await instance
    .get(EXPERT_SCORE)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getAvgResponseTime = async () => {
  let resp;
  await instance
    .get(AVG_RES_TIME)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getRecentRatings = async () => {
  let resp;
  await instance
    .get(RECENT_RATINGS)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getBestRatings = async () => {
  let resp;
  await instance
    .get(BEST_RATINGS)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getWorstRatings = async () => {
  let resp;
  await instance
    .get(WORST_RATINGS)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getBetterRatings = async () => {
  let resp;
  await instance
    .get(BETTER_RATINGS)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getDomainsByExpert = async (id, geoValue, bool, domainId) => {
  let resp;
  await instance
    .get(DOMAIN_BY_EXPERTS(id, geoValue, bool, domainId))
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getRatingGroupsByGeo = async (id, geoValue, bool, domainIds) => {
  let resp;
  await instance
    .get(GET_RATINGS_GROUPS(id, geoValue, bool, domainIds))
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getTotalAnsweredTrend = async () => {
  let resp;
  await instance
    .get(TOTAL_ANSWERED_TREND)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getExpertScoreTrend = async () => {
  let resp;
  await instance
    .get(EXPERT_SCORE_TREND)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getSlaComplianceTrend = async () => {
  let resp;
  await instance
    .get(SLA_COMPLIANCE_TREND)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getResponseTimeTrend = async () => {
  let resp;
  await instance
    .get(RESPONSE_TIME_TREND)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};
/* APIs for my stats end */

export const getAttachmentShowURL = async (payload) => {
  let resp;
  // console.log('payload 14', payload)
  await instance
    .post(GET_IMAGE_ATTACHMENT_URL, payload)
    .then((res) => {
      resp = res;
    })
    .catch((err) => {
      handleError(err);
    });

  return resp;
};

export const declineQuestionExpert = async (payload) => {
  let response;
  await instance
    .post(EXPERT_DECLINE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const askClarificationExpert = async (payload) => {
  let response;
  await instance
    .post(ASK_CLARIFICATION, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getQuestionDraftData = async (id) => {
  let response;
  await instance
    .get(EXPERT_GET_DRAFT_DATA(id))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const sendQuestionDraftData = async (payload) => {
  let response;
  await instance
    .post(EXPERT_SEND_DRAFT_DATA, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const expertAnswerQuestion = async (payload, isEdit) => {

  let response;
  await instance
    .post(
      isEdit ? EXPERT_UPDATE_ANSWER_API : EXPERT_ANSWER_QUESTION_API,
      payload
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

const removeUndefinedValues = (val) => {
  val.filter((item) => item !== undefined)
}
export const deleteAnswerrecord = async (answerUuid) => {
  let response;

  let payload=[]
  await instance
    .post(DELETE_ANSWER_RECORD_API,answerUuid)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
const chunkArray = (array, size) => {
  return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
    array.slice(index * size, index * size + size)
  );
};

export const getDeclinedAnswerRatings = (answerUuid, docId) => {
  // console.log("getting docid", docId);
  store.dispatch(
    addSearchedAnswerUuidInList([...new Set(answerUuid)], [...new Set(docId)])
  );

  return instance
    .get(GET_ANSWER_RATING(answerUuid, docId))
    .then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        // console.log("success", res.data.success);
      }
      store.dispatch(updateSearchData2(res.data.data));
      store.dispatch(getRatingsDataInSearchSuggestions(res.data.data));
    })
    .catch((err) => {
      handleError(err);
    });
};

export const declinedAnswers = async (id) => {
  let response;
  let answerUuids = [];
  let docIds = [];
  let userUuids = [];
  let allInlineImages = [];
  await instance
    .get(DECLINED_ANSWERS_API(id))
    .then(async(res) => {
      if (res === undefined) {
        return;
      }
      res.data.data[0].searchData = formatVideoDocData(
        res.data.data[0].searchData
      );

      res.data.data[0].searchData.filter((obj) => {
        if (obj.docType === undefined) {
          obj.docType = "expertqa";
        }
        obj.answers.filter((answer) => {
          // console.log("answer")
          if (answer.docId === null) {
            delete answer.docId;
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                      // console.log("png route")
                      let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;
                      answer.answerText = answer.answerText.replaceAll(
                        replacedContent,
                        imgTag
                      );

                      // console.log("answer text", answer.answerText)
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answerText = answer.answerText.replace(
                        replacedContent,
                        imgTag
                      );
                      // console.log("replacedContent", replacedContent);
                      // console.log("replacedContent1", imgTag);
                    }

                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
        if (obj.docType === "expertqa") {
          // console.log('object',obj.answers[0].expertImage.uuid);

          obj.answers.filter((answer) => {
            // console.log('answers filter',answer)
            userUuids.push(answer.expertImage.uuid)
            if (answer.docId === null) {
              delete answer.docId;
            }
            answer.attachmentURL = [];
            answer.attachmentVideo = [];
            answer.attachments.filter((attachment) => {
              if (
                attachment.name.includes(".jpeg") ||
                attachment.name.includes(".jpg") ||
                attachment.name.includes(".png") ||
                attachment.name.includes(".JPEG") ||
                attachment.name.includes(".JPG") ||
                attachment.name.includes(".PNG")
              ) {

                let payload = { name: attachment.name };
                // console.log('payload 13', payload)
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    answer.attachmentURL.push(res1.data.data);
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              if (
                attachment.name.includes(".mp4") ||
                attachment.name.includes(".mov")
              ) {
                let payload = { name: attachment.name };
                // console.log('payload 12', payload)
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    attachment.objectUrl = res1.data.data.objectUrl;
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
            });
            // });
            if (answer.docId === undefined) {
              answer.answerUuid = answer.origAnswerUuid;
              if (answer.answerUuid !== undefined) {
                answerUuids.push(
                  answer.origAnswerUuid !== undefined
                    ? answer.origAnswerUuid
                    : answer.answerUuid
                );
              }
            } else {
              if (answer?.docId !== undefined) {
                docIds.push(answer.docId);
              }

            }
          });
        }
        if (obj.doctype !== "expertqa") {
          obj.answers.filter((answer) => {
            docIds.push(answer.docId);
            if (obj.docType === "Pdf" || obj.docType === "Image") {
              answer.attachmentURL = [];
              answer.attachments.filter((attachment) => {
                if (
                  attachment.name.includes(".jpeg") ||
                  attachment.name.includes(".jpg") ||
                  attachment.name.includes(".png") ||
                  attachment.name.includes(".JPEG") ||
                  attachment.name.includes(".JPG") ||
                  attachment.name.includes(".PNG")
                ) {
                  let payload = { name: attachment.name };
                  // console.log('payload 11', payload)
                  instance
                    .post(GET_IMAGE_ATTACHMENT_URL, payload)
                    .then((res1) => {
                      if (res1 === undefined) {
                        return;
                      }
                      answer.attachmentURL.push(res1.data.data);
                      // dispatch(res.data.data[0].searchData);
                    })
                    .catch((err) => {
                      handleError(err);
                    });
                }
              });
            }
            if (obj.docType === "Thread") {
              if (obj.threadType === "REUSABLE_THREAD_QA") {
                answer.threadAttachments.unshift([]);
                answer.threadAttachments.unshift([]);
              }
              answer.threadAttachmentsURL = [];
              answer.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  answer.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png") ||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      // console.log('payload 10', payload)
                      instance
                        .post(GET_IMAGE_ATTACHMENT_URL, payload)
                        .then((res1) => {
                          if (res1 === undefined) {
                            return;
                          }
                          asdffgh.push(res1.data.data);
                          // dispatch(res.data.data[0].searchData);
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  answer.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            if (obj.docType === "Video") {
              obj.videoAttachmentURL = [];
              let payload = {
                name: obj.docName,
              };
              // console.log('payload9',payload)
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  obj.videoAttachmentURL.push(res1.data.data);
                  // dispatch(res.data.data[0].searchData);
                })
                .catch((err) => {
                  handleError(err);
                });
              obj.suggestions.filter((suggestion) => {
                suggestion.videoAttachmentURL = obj.videoAttachmentURL;
                suggestion.suggestions = obj.suggestions;
                docIds.push(suggestion.answers[0].docId);
              });
            }
          });
        }
      });
      // console.log("answerUuids",answerUuids)
      
      const chunkSize = 50;
      const answerUuidChunks = chunkArray(answerUuids, chunkSize);
      const docIdChunks = chunkArray(docIds, chunkSize);

      store.dispatch(updateRatingBoolean(true));

      getFiles([...new Set(allInlineImages)]);

      // Wait for all answer ratings requests to complete
      await Promise.all(
        answerUuidChunks.map((chunk, index) => getDeclinedAnswerRatings(chunk, docIdChunks[index] || []))
      );

      // Now update the rating boolean
      store.dispatch(updateRatingBoolean(false));

      getExpertsProfilePics(userUuids, undefined);
      store.dispatch(updateNewDeclinedLoader(false));

      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

//API calls for Expert end//

export const anotherExpertAnsweredQuestion = async (id) => {
  let resp;
  let userUuids = [];
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  await instance
    .get(URL_REDIRECTION_DATA_API(id))
    .then((res) => {
      if (res.data.data.answers.length > 0) {
        res.data.data.answers.filter((answer) => {
          userUuids.push(answer.expertUuid);
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                      // store.dispatch(getTrendingQA(res.data.data));
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachmentURL = [];
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              // console.log('payload8', payload)
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
          if (answer.docId === undefined) {
            if (answer.answerUuid !== undefined) {
              answerUuids.push(
                answer.originalAnswerUuid !== undefined
                  ? answer.originalAnswerUuid
                  : answer.answerUuid
              );
            }
          } else {
            docIds.push(answer.docId);
          }
        });
      }
      resp = res;
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  getFiles([...new Set(allInlineImages)]);
  getExpertsProfilePics(userUuids, undefined);
  getAnswerRatings(answerUuids, docIds, undefined);
  return resp;
};

export const fetchSearchResultForEditor = async (payload) => {
  let responses;
  let userUuids = [];
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  if (payload.domains.length > 0) {
    payload.domains = payload.domains.map((obj) => obj.name);
  }
  payload.unified = true;
  await instance
    .post(SEARCH_DATA_URL, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (res.data.data[0].searchData.length > 0) {
        res.data.data[0].searchData.filter((obj) => {
          obj.questionUuidCopy = obj.questionUuid;
          obj.answers.filter(async (answer) => {
            answer.expertUuid = answer.expert.userUuidStr;
            answer.answerCopy = answer.answerText;
            if (
              answer.inlineImages !== null &&
              answer.inlineImages.length > 0
            ) {
              allInlineImages = allInlineImages.concat(answer.inlineImages);
              for (let i = 0; i < answer.inlineImages.length; ++i) {
                let payload = { name: answer.inlineImages[i] };
                // console.log('payload7', payload)
                instance
                  .post(GET_FILES, answer.inlineImages)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }


                    if (answer.inlineImages[i].includes(".png")) {
                      let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;
                      answer.answerText = answer.answerText.replaceAll(
                        replacedContent,
                        imgTag
                      );
                      // dispatch(res.data.data[0].searchData);
                      // console.log("png replaced",answer.answerText)
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answerText = answer.answerText.replace(
                        replacedContent,
                        imgTag
                      );
                      // console.log("replaced",answer.answerText)
                      // dispatch(res.data.data[0].searchData);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                // instance
                //   .post(GET_IMAGE_ATTACHMENT_URL, payload)
                //   .then((res1) => {
                //     if (res1 === undefined) {
                //       return;
                //     }
                //     if (res1.data.success) {
                //       if (answer.inlineImages[i].includes(".png")) {
                //       } else {
                //         let imgTag = `<img style='max-width:50%' src=${res1.data.data.src}></img>`;

                //         let replacedContent = answer.inlineImages[i];
                //         answer.answerText = answer.answerText.replaceAll(
                //           replacedContent,
                //           imgTag
                //         );
                //       }
                //     }
                //   })
                //   .catch((err) => {
                //     handleError(err);
                //   });
              }

            }
          });
          if (obj.docType === "expertqa") {
            // console.log("entered in expertqa")
            getSearchDataKnowledgeEntry(obj);
            obj.answers.filter((answer) => {
              // console.log('answer value',answer)
              answerUuids.push(answer.origAnswerUuid);
              userUuids.push(answer.expertImage.uuid);
              answer.attachmentURL = [];
              answer.attachmentVideo = [];
              answer.attachments.filter((attachment) => {
                // console.log('payload6', payload)
                if (
                  attachment.name.includes(".jpeg") ||
                  attachment.name.includes(".jpg") ||
                  attachment.name.includes(".png") ||
                  attachment.name.includes(".JPEG") ||
                  attachment.name.includes(".JPG") ||
                  attachment.name.includes(".PNG")
                ) {
                  let payload = { name: attachment.name };
                  instance
                    .post(GET_IMAGE_ATTACHMENT_URL, payload)
                    .then((res1) => {
                      if (res1 === undefined) {
                        return;
                      }
                      answer.attachmentURL.push(res1.data.data);
                    })
                    .catch((err) => {
                      handleError(err);
                    });
                }
                if (
                  attachment.name.includes(".mp4") ||
                  attachment.name.includes(".mov")
                ) {
                  answer.attachmentVideo.push(attachment);
                }
              });
            });
          }
        });
        getFiles([...new Set(allInlineImages)]);
        getAnswerRatings(answerUuids, [], undefined);
        getExpertsProfilePics(userUuids, undefined);
      }
      responses = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return responses;
};

export const getAtomizerData = async (type) => {
  let response;
  await instance
    .get(CM_ATOMIZER_API(type))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const AtomizerJobsData = async (payload) => {
  let response;
  await instance
    .post(CM_JOBS_REVIEW_API, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const postPdfAtomizer = async (payload, bool, oldSoid) => {
  // store.dispatch(handleResetState(initialState));
  let formData = new FormData();
  if (payload.sourceType === 'Video') {
    bool = false;
  }
  const payloadForm = () => {
    switch (bool) {
      case true:
        return JSON.stringify({
          source: payload?.sourceType?.toLowerCase(),
          jobId: payload.jobId,
          usageAccess: "public",
          groupId: currentGroup,
          oldSoId: oldSoid,
          domainIds:
            payload.domainIds.length === 0
              ? ""
              : payload.domainIds
                .map((domain) => domain.indexId)
                .sort()
                .toString(),
        });
      case false:
        return JSON.stringify({
          source: payload?.sourceType?.toLowerCase(),
          jobId: payload.jobId,
          usageAccess: "public",
          groupId: currentGroup,
          domainIds:
            payload.domainIds.length === 0
              ? ""
              : payload.domainIds
                .map((domain) => domain.indexId)
                .sort()
                .toString(),
        });

      default:
        return JSON.stringify({
          source: payload?.sourceType?.toLowerCase(),
          jobId: payload.jobId,
          usageAccess: "public",
          groupId: currentGroup,
          similarDocs: true,
          domainIds:
            payload.domainIds.length === 0
              ? ""
              : payload.domainIds
                .map((domain) => domain.indexId)
                .sort()
                .toString(),
        });
    }
  };
  formData.append("metadata", payloadForm());
  // formData.append("files", handleUploadFile());
  formData.append("files", payload?.uploadFileData);
  // const onSumbitValueChange = {
  //   sourceType: "",
  //   jobId: "",
  // };
  let resp;
  await instance
    .post(postPdf, formData)
    .then((res) => {
      if (
        res?.data?.message === "Similar docs have been fetched successfully." &&
        res?.data?.data.length > 0
      ) {
        store.dispatch(handleResponse(res.data?.data));
        store.dispatch(handleLoadingSpinner(false));
        store.dispatch(
          advanceFilterModalToggle({ bool: true, value: "atomizerResponse" })
        );
      }
      if (
        res?.data?.message === "Request is being processed in background." ||
        res?.success === true
      ) {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        // store.dispatch(initailPage(onSumbitValueChange));
        store.dispatch(handleResetState(initialState));
        store.dispatch(handleLoadingSpinner(false));
        store.dispatch(handleDoubleInput(true));
      }
      if (
        (res?.data?.message ===
          "Similar docs have been fetched successfully." &&
          !res?.data?.data.length > 0) ||
        (res?.data?.message !== "Request is being processed in background." &&
          res?.data?.data === undefined)
      ) {
        postPdfAtomizer(payload, false);
      }
    })
    .catch((err) => {
      handleError(err);
      // store.dispatch(initailPage(onSumbitValueChange));
      store.dispatch(handleResetState(initialState));
      store.dispatch(handleLoadingSpinner(false));
      store.dispatch(handleDoubleInput(true));

      // store.dispatch(initailPage("PDF"));
    });
  // store.dispatch(handleLoadingSpinner(false));
  return resp;
};

export const listOfPdfUrl = async (payload) => {
  let formData = new FormData();
  formData.append(
    "metadata",
    JSON.stringify({
      source: "csv",
      jobId: payload.jobId,
      usageAccess: "public",
      groupId: currentGroup,
    })
  );
  formData.append("files", payload?.uploadFileData);

  let resp;
  await instance
    .post(postPdf, formData)
    .then((res) => {
      if (
        res?.data?.message === "Request is being processed in background." ||
        res?.success === true
      ) {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        store.dispatch(handleResetState(initialState));
      } else {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      store.dispatch(handleLoadingSpinner(false));
    })
    .catch((err) => {
      handleError(err);
      store.dispatch(handleResetState(initialState));
      store.dispatch(handleLoadingSpinner(false));
    });
  return resp;
};

export const postScrapUrl = async (payload) => {
  
  const updateFrencyValue = () => {
    if (payload?.Frequency === "Once") {
      return 1;
    }
    if (payload?.Frequency === "Monthly") {
      return 2;
    }
  };
  const requestPayload = {
    crawlImage: payload?.isIncludeImageChecked,
    crawlPdf: payload?.isIncludePdfChecked,
    crawlingFrequency: payload?.Frequency,
    depth: payload?.UrlDepth,
    jobId: payload?.Name,
    url: payload?.Link,
  };
  const ScrapInitailState = {
    sourceType: "Scrape URL",
    isIncludeImageChecked: false,
    isIncludePdfChecked: false,
    uploadFileData: null,
    Name: "",
    UrlDepth: "",
    Frequency: "",
    Link: "",
  };
  await instance
    .post(scrapUrl, requestPayload)
    .then((res) => {
      if (
        res?.data?.message === "Your request is being processed in background."
      ) {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        store.dispatch(handleResetState(ScrapInitailState));
        // store.dispatch(initailPage(onSumbitValueChange));
        store.dispatch(handleLoadingSpinner(false));
      }
    })
    .catch((err) => {
      handleError(err);
      store.dispatch(handleResetState(ScrapInitailState));
      // store.dispatch(initailPage(onSumbitValueChange));
      store.dispatch(handleLoadingSpinner(false));
    });
  store.dispatch(handleResetState(ScrapInitailState));
  // store.dispatch(initailPage(onSumbitValueChange));
  store.dispatch(handleLoadingSpinner(false));
};

const pdfUrl = async (payload) => {
  const formData = new FormData();
  formData.append(
    "metadata",
    JSON.stringify({
      source: "url",
      url: payload?.UrlValue,
      jobId: payload.jobId,
      usageAccess: "public",
      groupId: currentGroup,
    })
  );

  await instance
    .post(postPdf, formData)
    .then((res) => {
      if (res?.data?.message === "Request is being processed in background.") {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });

        store.dispatch(handleResetState(initialState));
      }
    })
    .catch((err) => {
      handleError(err);
    });
  store.dispatch(handleResetState(initialState));
  store.dispatch(handleLoadingSpinner(false));
};

export const pdfUrlData = async (payload) => {
  const formData = new FormData();
  formData.append(
    "metadata",
    JSON.stringify({
      source: "url",
      url: payload?.UrlValue,
      jobId: payload.jobId,
      usageAccess: "public",
      groupId: currentGroup,
      similarDocs: true,
    })
  );

  await instance
    .post(postPdf, formData)
    .then((res) => {
      // resp = res;
      if (res?.data?.success === true) {
        pdfUrl(payload);
      }
    })
    .catch((err) => {
      handleError(err);
    });
  // store.dispatch(initailPage(onSumbitValueChange));

  store.dispatch(handleResetState(initialState));

  store.dispatch(handleLoadingSpinner(false));
};

export const QAPostForm = async (payload, setSeekerEmail, setExpertEmail) => {
  const formData = new FormData();
  formData.append("seeker", payload?.Seeker);
  formData.append("expert", payload?.Expert);
  formData.append("file", payload.uploadFileData);

  await instance
    .post(QA_Url, formData)
    .then((res) => {
      if (
        res?.data?.message ===
        "Your request is being processed in background." ||
        "Your request is being processed. Please check logs after sometime."
      ) {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSeekerEmail([]);
        setExpertEmail([]);
        store.dispatch(handleResetState(initialState));
      }
      store.dispatch(handleLoadingSpinner(false));
      setSeekerEmail([]);
      setExpertEmail([]);
      store.dispatch(handleResetState(initialState));
    })
    .catch((err) => {
      handleError(err);
      setSeekerEmail([]);
      setExpertEmail([]);
      store.dispatch(handleResetState(initialState));
    });
  setSeekerEmail([]);
  setExpertEmail([]);
  // store.dispatch(initailPage(onSumbitValueChange));
  store.dispatch(handleResetState(initialState));
  store.dispatch(handleLoadingSpinner(false));
};

export const Bloomfire = async (payload) => {
  const formData = new FormData();

  for (let i = 0; i < payload?.uploadFileData?.length; i++) {
    formData.append("files", payload?.uploadFileData[i]);
  }
  await instance
    .post(bloomFire, formData)
    .then((res) => {
      if (
        res?.data?.message ===
        "Request is being processed in background. Please check after sometime."
      ) {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        store.dispatch(handleResetState(initialState));
        store.dispatch(enableMutliple(true));
      }
      store.dispatch(handleLoadingSpinner(false));
      store.dispatch(handleResetState(initialState));
    })
    .catch((err) => {
      handleError(err);
      store.dispatch(handleResetState(initialState));
    });
  store.dispatch(handleLoadingSpinner(false));
  store.dispatch(handleResetState(initialState));
  store.dispatch(enableMutliple(true));
};

export const getBloomFireData = async () => {
  let resp;

  await instance
    .get(getBloomFire)
    .then((res) => {
      store.dispatch(getCategories(res?.data?.data));
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

export const getFrquencyList = async () => {
  let resp;
  await instance
    .get(Atomizer_Url)
    .then((res) => {
      store.dispatch(getFrequencyList(res?.data?.data));
    })
    .catch((err) => {
      resp = err;
      handleError(err);
    });
  return resp;
};

const handleMultifiles = async (payload) => {
  const formData = new FormData();

  formData.append(
    "metadata",
    JSON.stringify({
      source: "multiple",
      jobId: payload.jobId,
      usageAccess: "public",
      groupId: currentGroup,
      domainIds:
        payload.domainIds.length === 0
          ? ""
          : payload.domainIds
            .map((domain) => domain.indexId)
            .sort()
            .toString(),
    })
  );
  for (let i = 0; i < payload?.uploadFileData?.length; i++) {
    formData.append("files", payload?.uploadFileData[i]);
  }

  await instance
    .post(postPdf, formData)
    .then((res) => {
      if (res?.data?.message === "Request is being processed in background.") {
        toast.success(submitRatingSuccessToast(res?.data?.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        store.dispatch(handleResetState(initialState));
      }
      store.dispatch(handleResetState(initialState));
      store.dispatch(handleLoadingSpinner(false));
      store.dispatch(enableMutliple(true));
    })
    .catch((err) => {
      handleError(err);
      store.dispatch(handleLoadingSpinner(false));
      store.dispatch(handleResetState(initialState));
    });
};

export const handleMultipleFiles = async (payload) => {
  const formData = new FormData();
  let resp;

  formData.append(
    "metadata",
    JSON.stringify({
      source: "multiple",
      jobId: payload.jobId,
      usageAccess: "public",
      groupId: currentGroup,
      similarDocs: true,
      domainIds:
        payload.domainIds.length === 0
          ? ""
          : payload.domainIds
            .map((domain) => domain.indexId)
            .sort()
            .toString(),
    })
  );
  for (let i = 0; i < payload?.uploadFileData?.length; i++) {
    formData.append("files", payload?.uploadFileData[i]);
  }

  await instance
    .post(postPdf, formData)
    .then((res) => {
      resp = res;
      if (
        res?.data?.message === "Similar docs have been fetched successfully." ||
        res?.data === undefined ||
        res?.data?.success === true
      ) {
        handleMultifiles(payload);
      }
    })
    .catch((err) => {
      handleError(err);
      store.dispatch(handleResetState(initialState));
      store.dispatch(handleLoadingSpinner(false));
    });

  return resp;
};

export const postBlommfireCaegory = async (payload, setSelectedOptions) => {
  await instance
    .post(postBloonfire, payload?.selectedCategories)
    .then((res) => {
      toast.success(submitRatingSuccessToast(res?.data?.message), {
        position: toast.POSITION.TOP_RIGHT,
      });

      store.dispatch(handleResetState(initialState));
      store.dispatch(handleLoadingSpinner(false));
      setSelectedOptions([]);
      store.dispatch(handleResetCategories(!payload?.Catogarie));
    });
};

export const generateAIText = async (payload) => {
  let response;
  await instance
    .post(GENERATE_TEXT, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getroutinglevels = async () => {
  let response;
  await instance
    .get(ADMIN_ROUTING_LEVELS_DATA)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.filter((obj) => {
        obj.value = obj.name;
        obj.label = obj.name.charAt(0).toUpperCase() + obj.name.slice(1);
      });
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getExpertAnalyticsDataInOverview = async (
  geoLevelId,
  geoLevelValue,
  domainIDs
) => {
  let response;
  await instance
    .get(GET_EXPERT_OVERVIEW_ANALYTICS(geoLevelId, geoLevelValue, domainIDs))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getExpertQCountsInOverview = async (domainIDs) => {
  let response;
  await instance
    .get(GET_EXPERTS_QCOUNTS(domainIDs))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getroutinglevelsCountry = async (parent = undefined) => {
  let response;
  await instance
    .get(
      `${ADMIN_GEOLEVELS}?level=country${parent === undefined ? "" : `&parent=${parent}`
      }`
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      let newData = [];
      res.data.data.filter((obj) => {
        newData.push({ name: obj, label: obj, value: obj });
      });
      response = newData;
    })
    .catch((err) => {
      handleError(err);
    });
  return response
  // if(parent===undefined) return []
  // else return response;
};

export const getroutinglevelsRegion = async () => {
  let response;
  await instance
    .get(`${ADMIN_GEOLEVELS}?level=region`)
    .then((res) => {
      if (res === undefined) {
        return;
      }

      let newData = [];
      res.data.data.filter((obj) => {
        newData.push({ name: obj, label: obj, value: obj });
      });
      response = newData;
      store.dispatch(geoLevelRegionAction(newData));
    })
    .catch((err) => {
      handleError(err);
    });

  return response;
};

export const fetchFrequecyForGDRIVE = async () => {
  let response;
  await instance
    .get(FETCH_GDRIVE_FREQUENCY)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchDocumentsForGDRIVE = async () => {
  let response;
  await instance
    .get(FETCH_GDRIVE_DOCUMENTS)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const submitSourceDocsForCM = async (payload) => {
  let response;
  await instance
    .post(SOURCE_DOCS, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const updateGdriveAttrs = async (payload) => {
  let response;
  await instance
    .put(UPDATE_GDRIVE_ATTR, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getSearchSuggestionsForCMRecords = async (payload) => {
  let response;
  await instance
    .post(GET_SEARCH_SUGGESTIONS, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getSearchSuggestionsCount = async (payload) => {
  let response;
  await instance
    .post(SEARCH_SUGGESTIONS_COUNT, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};


export const deleteSearchSuggestionRecord = async (payload) => {
  let response;
  await fetch(BASE_URL + DELETE_SEARCH_SUGGESTION_RECORD, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Cookie: document.cookie,
    },
    body: payload,
  })
    .then((res) => res.json())
    .then((res1) => {
      // if (res1.status && res1.status === 401) {
      //   userLogout();
      // }
      response = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getSearchSuggestionDetailRecord = async (questionUuid) => {
  let response;
  let answerUuids = [];
  let docIds = [];
  let inlineImages = [];
  await instance
    .get(SEARCH_SUGGESTION_DETAIL(questionUuid))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      if (res.data.data !== undefined && res.data.data.length > 0) {
        res.data.data.filter((obj) => {
          if (obj.docId === undefined) {
            if (obj.answerUuid !== undefined) {
              answerUuids.push(
                obj.originalAnswerUuid !== undefined
                  ? obj.originalAnswerUuid
                  : obj.answerUuid
              );
            }
          } else {
            docIds.push(obj.docId);
          }
          if (obj.inlineImages !== null && obj.inlineImages.length > 0) {
            inlineImages = inlineImages.concat(obj.inlineImages);
            instance
              .post(GET_FILES, obj.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < obj.inlineImages.length; ++i) {
                    if (obj.inlineImages[i].includes(".png")) {
                      let replacedContent = `[content|${obj.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${
                        // obj.inlineImages[
                        //   obj.inlineImagesList[i]
                        // ]
                        res1.data.data[obj.inlineImages[i]]
                        }></img>`;
                      obj.answer = obj.answer.replaceAll(
                        replacedContent,
                        imgTag
                      );
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[obj.inlineImages[i]]
                        }></img>`;
                      let replacedContent = obj.inlineImages[i];
                      obj.answer = obj.answer.replace(
                        replacedContent,
                        imgTag
                      );
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (obj.answer.includes("contenteditable")) {
            let newAnswer = obj.answer.replace("contenteditable=", "");
            obj.answer = newAnswer;
          }
        });
        getFiles([...new Set(inlineImages)]);
        getAnswerRatings(answerUuids, docIds, undefined);
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getExpertRecordsCount = async (payload) => {
  let response;
  await instance
    .post(CM_EXPERT_RECORDS_COUNT, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      store.dispatch(cmrUpdatePage(false))
      handleError(err);
    });
  return response;
};
export const AtomizerJobAPI = async (payload) => {
  let response;
  await instance
    .post(JOB_API, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const rfpUpload = async (payload) => {
  let response;
  await instance
    .post(RFP_UPLOAD, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getCrawlDocsList = async () => {
  let response;
  await instance
    .get(GET_CRAWL_DOCS)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const AtomizerDeleteJob = async (payload) => {
  let response;
  await instance
    .delete(DELETE_JOBS, { data: payload })
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getVerifiedDocs = async (payload) => {
  let response;
  await instance
    .get(VERIFIED_DOCS + payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getCsvUploadedList = async () => {
  let response;
  await instance
    .get(GET_UPLOADED_CSV)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getExpertrecords = async (payload) => {
  let response;
  await instance
    .post(CM_EXPERT_RECORDS, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      store.dispatch(cmrUpdatePage(false))
      handleError(err);
    });
  return response;
};
export const fetchRfpUpload = async () => {
  let response;
  await instance
    .get(RFP_DOC)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const amendHeaders = async (soid) => {
  let response;
  await instance
    .post(AMEND_HEADERS(soid), {})
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getInlineImageForCsvUpload = async (files) => {
  let resp;
  await instance
    .post(`${GET_FILES}?csv=true`, files)
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      resp = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getDetailedrecord2 = async (userType, ids, status) => {
  let response;
  let payload = {
    questionIds: ids,
    userType: userType,
    answered: status
  }
  await instance
    .post(CM_DETAILED_RECORDS, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }      
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getDetailedrecord = async (userType, ids, status) => {
  let response;
  let payload = {
    questionIds: ids,
    userType: userType,
    answered: status
  }
  await instance
    .post(CM_DETAILED_RECORDS, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      // console.log("getInline",Object.keys(res.data.data))
      Object.keys(res.data.data).filter(id=>{
        res.data.data[id].filter(ans=>{
          // console.log(ans.inlineImages,'inlineObj')
          if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
              // allInlineImages = allInlineImages.concat(answer.inlineImages);
              instance
                .post(GET_FILES, ans.inlineImages)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  if (res1.data.success) {
                    for (let i = 0; i < ans.inlineImages.length; ++i) {
                      if (ans.inlineImages[i].includes(".png")) {
                        let replacedContent = `[content|${ans.inlineImages[i].split(".")[0]
                          }|]`;
                        let imgTag = `<img style='max-width:50%' src=${res1.data.data[ans.inlineImages[i]]
                          }></img>`;
                          ans.answer = ans.answer.replaceAll(
                          replacedContent,
                          imgTag
                        );
                        store.dispatch(refreshTrendingData("refreshed"));
                      } else {
                        let imgTag = `<img style='max-width:50%' src=${res1.data.data[ans.inlineImages[i]]
                          }></img>`;

                        let replacedContent = ans.inlineImages[i];
                        ans.answer = ans.answer.replace(
                          replacedContent,
                          imgTag
                        );
                        store.dispatch(refreshTrendingData("refreshed"));
                      }
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
        })
      })
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const updateCmDomains = async (payload) => {
  let resp;
  await instance
    .post(EDIT_DATA_API, payload)
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      resp = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};

export const getRoutingHistory = async (id) => {
  let response;
  await instance
    .get(`${GET_ROUTING_HISTORY}?questionid=${id}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const deleteDataCM = async (payload) => {
  let resp;
  await instance
    .delete(DELETE_DATA_API, { data: payload })
    .then((res1) => {
      if (res1 === undefined) {
        return;
      }
      resp = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return resp;
};
export const getFilesRFP = async (files) => {
  let response;
  if (files && files.length > 0) {
    await instance
      .post(`${GET_FILES}?rfp=true`, files)
      .then((res) => {
        if (res === undefined) {
          return;
        }
        response = res;
      })
      .catch((err) => {
        handleError(err);
      });
    return response;
  }
};

export const getTotalQuestionCount = async (id, value, domain, type) => {
  let response;
  await instance
    .get(CM_OVERVIEW_TOTAL_QUESTION_COUNT(id, value, domain, type))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getTotalUserCount = async (id, value, domain, usertype) => {
  let response;
  await instance
    .get(CM_OVERVIEW_USER_COUNT(id, value, domain, usertype))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getSeekerAnalytics = async (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  setCount
) => {
  let response;
  await instance
    .get(
      seekerAnalytics(geoLevelId, geoLevelValue, userType, domainId, setCount)
    )
    .then((res) => {
      setCount(res.data?.data?.length);
      response = res?.data?.data?.map((item, index) => ({
        key: index, // Assigning a unique ID to each row
        Geo: item.location,
        seeker: `${item.firstName}\u00A0${item.lastName}`,
        Searched: item.searchedQuestion,
        Submitted: item.submittedQuestion,
        Rated: item.rated,
        TrendingViews: item.trendingViews,
        DeflectionRate: `${item.searchedSubmittedRatio}`,
      }));
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getSeekerBadges = async (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  filter,
  page,
  searchText,
  entryCount
) => {
  let response;
  await instance
    .get(
      seekerBadges(
        geoLevelId,
        geoLevelValue,
        userType,
        domainId,
        filter,
        page,
        searchText,
        entryCount
      )
    )
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getExpertAnalytics = async (
  geoLevelId,
  geoLevelValue,
  domainId,
  setCount
) => {
  let response;
  await instance
    .get(expertanalytics(geoLevelId, geoLevelValue, domainId))
    .then((res) => {
      store.dispatch(getExpertAnalyticsDataInCmOverview(res.data.data));
      store.dispatch(
        getExpertAnalyticsDataInCmOverviewForQuestions(res.data.data)
      );
      setCount(res.data.data.length);
      response = res?.data?.data?.map((item, index) => ({
        key: index, // Assigning a unique ID to each row
        Geo: item.location,
        Expert: `${item.name}`,
        Answered: item.answers,
        RatingCNT: item.ratingCount,
        AvgOfRating: item.avgRating,
        Views: item.views,
        Rated: `${item.percentRated}`,
      }));
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchExpertRank = async () => {
  let response;
  await instance
    .get(ExpertRankUrl)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  // console.log("res", response);
  return response;
};

export const fetchExpertWiseCuration = async (
  geoLevelId,
  geoLevelValue,
  domainId,
  Category,
  order
) => {
  let response;
  await instance
    .get(
      expertWiseCuration(geoLevelId, geoLevelValue, domainId, Category, order)
    )
    .then((res) => {
      store.dispatch(getCurationCountCMExpert(res.data.data));
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getCurationDataForGraph = async (
  geoLevelId,
  geoLevelValue,
  domainIds,
  category,
  order
) => {
  let response;
  await instance
    .get(
      FETCH_CURATION_GRAPH_DATA(
        geoLevelId,
        geoLevelValue,
        domainIds,
        category,
        order
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getAuditLogs = async (
  duration,
  action,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType, actionName
) => {
  let response;
  await instance
    .get(
      GET_AUDIT_LOGS(
        duration,
        action,
        geoLevelId,
        geoLevelValue,
        domainIds,
        userType, actionName
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getDomainsCountInGraphs = async (
  geoLevelId,
  geoLevelValue,
  domainId,
  userType
) => {
  let response;
  await instance
    .get(
      GET_DOMAINS_COUNT_GRAPHS(geoLevelId, geoLevelValue, domainId, userType)
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    });
  return response;
};

export const getSeekerAnalyticsQue = async (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  filter,
  page,
  searchText,
  entryCount
) => {
  let response;
  await instance
    .get(
      seekeranalyticsque(
        geoLevelId,
        geoLevelValue,
        userType,
        domainId,
        filter,
        page,
        searchText,
        entryCount
      )
    )
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getQuestionsSearchedCount = async (
  geoLevelId,
  geoLevelValue,
  duration,
  source,
  domainId,
  userType
) => {
  let response;
  await instance
    .get(
      QUESTIONS_SEARCHED_COUNT(
        geoLevelId,
        geoLevelValue,
        duration,
        source,
        domainId,
        userType
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getDomainsTimelineInOverview = async (
  duration,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) => {
  let response;
  await instance
    .get(
      GET_DOMAINS_TIMELINE(
        duration,
        geoLevelId,
        geoLevelValue,
        domainIds,
        userType
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getQuestionsCountByDay = async (
  duration,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) => {
  let response;
  await instance
    .get(
      GET_QUESTIONS_COUNT_BY_DAY(
        duration,
        geoLevelId,
        geoLevelValue,
        domainIds,
        userType
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getDomainsCountData = async (
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) => {
  let response;
  await instance
    .get(GET_DOMAIN_WISE_COUNT(geoLevelId, geoLevelValue, domainIds, userType))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
// Document_Tab

export const Fetch_Document = async (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  channelId,
  channel
) => {
  let response;
  // console.log("domainId", domainId);
  await instance
    .get(
      Document_Tab(
        geoLevelId,
        geoLevelValue,
        domainId,
        userType,
        channelId,
        channel
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getDomainSpecificTimelineDataExpertOverview = async (
  domain,
  duration,
  geoLevelId,
  geoLevelValue,
  domainId,
  userType
) => {
  let response;
  await instance
    .get(
      DOMAIN_SPECIFIC_GRAPH(
        domain,
        duration,
        geoLevelId,
        geoLevelValue,
        domainId,
        userType
      )
    )
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getAnswerRatingForCM = async (type, id) => {
  let response;
  await instance
    .get(`${GET_ANSWER_RATING_CM}?${type}=${id}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getRerouteUser = async () => {
  let response;
  await instance
    .get(`${GET_FORCE_REROUTE_USER}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const transferOwnership = async (payload) => {
  let response;
  await instance
    .post(TRANSFER_OWNERSHIP, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
      if (res.data?.success) {
        toast.success(submitRatingSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const routeBackToExpert = async (payload) => {
  let response;
  await instance
    .post(REROUTE_RECORD, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const answerByCM = async (payload) => {
  let response;
  await instance
    .post(CM_ANSWER, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const expediteQuestion = async (payload) => {
  let response;
  await instance
    .post(CM_EXPEDITE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const cmDeleteAnswer = async (payload) => {
  let response;
  await instance
    .post(CM_DELETE_ANSWER, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchUsers_demoted = async (query) => {
  let response;
  await instance
    .get(GET_WATCHLIST_USER_DEMOTED(query))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getPermissions = async () => {
  let response;
  await instance
    .get(ADMIN_PERMISSION)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const generateQaPair = async (query) => {
  let response;
  await instance
    .post(EXPERT_GENERATE_QA, query)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getManageRoleUser = async () => {
  let response;
  await instance
    .get(`${ADMIN_MANAGE_ROLE}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res?.data?.data;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
  // return applyFilterActive(response);
};

export const getCreateRole = async () => {
  let response;
  await instance
    .get(`${CREATE_NEW_ROLE}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res?.data?.data;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
  // return applyFilterActive(response);
};

export const deleteRole = async (id, actionPerformed, setActionPerformed) => {
  let payload = {
    roleId: id,
  };
  let response;

  const rawResponse = await fetch(DELETE_ROLE, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      // console.log("response", res);
      response = res;
      if (res === undefined) {
        return;
      }
      if (res?.status == 200) {
        toast.success(
          submitRatingSuccessToast("Role has been deleted successfully"),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        // setActionPerformed(!actionPerformed);
      }
      return res;
    })
    .catch((err) => {
      if (err?.status == 403) {
        toast.error(submitRatingSuccessToast("Access is Denied"), {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else handleError(err);
    });
  // console.log("rawResponse", rawResponse);
  return rawResponse;
  // const content = await rawResponse.json();
  // console.log("content", content);
  // await instance
  //   .DELETE(DELETE_ROLE, payload)
  //   .then((res) => {
  //     response = res;
  //     // setActionPerformed
  //     console.log("res", res);
  //   })
  //   .catch((err) => {
  //     handleError(err);
  //   });
  // return content;
};

export const EditRole = async (payload, name) => {
  let response;
  await instance
    .post(EDIT_ROLE(name), payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      if (err?.response?.status == 500) {
        return toast.warn(
          submitRatingSuccessToast("This role already exists"),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      } else handleError(err);
    });
  return response;

  // const response = await fetch(EDIT_ROLE(name), {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   body: JSON.stringify(payload),
  // });
  // let response;
  // await instance
  //   .post(EDIT_ROLE(name), payload)
  //   .then((res) => {
  //     if (res === undefined) {
  //       return;
  //     }
  //     response = res;
  //   })
  //   .catch((err) => {
  //     console.log("error", err);
  //     if (err.response.status == 500) {
  //       return toast.warn(
  //         submitRatingSuccessToast("This role already exists"),
  //         {
  //           position: toast.POSITION.TOP_RIGHT,
  //         }
  //       );
  //     } else handleError(err);
  //   });
  // let response;
  // await fetch(BASE_URL + EDIT_ROLE(name), {
  //   method: "POST",
  //   credentials: "same-origin",
  //   headers: {
  //     Accept: "application/json",
  //     "Content-Type": "application/json",
  //     Cookie: document.cookie,
  //   },
  //   body: JSON.stringify(payload),
  // })
  //   .then((res) => res.json())
  //   .then((res1) => {
  //     // if (res1.status && res1.status === 401) {
  //     //   userLogout();
  //     // }
  //     response = res1;
  //   })
  //   .catch((err) => {
  //     console.log("error", err);
  // if (err?.response?.status == 500) {
  //   return toast.warn(
  //     submitRatingSuccessToast("This role already exists"),
  //     {
  //       position: toast.POSITION.TOP_RIGHT,
  //     }
  //   );
  // } else handleError(err);
  //   });
  // return response;
};

export const CreateRole = async (payload) => {
  let response;
  await instance
    .post(CREATE_ROLE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getAdminUsersList = async (page, size, sf, so, text, levelid, levelval, usertype, role, from, till, domain, statusList, activefrom, activetill) => {
  let response;
  await instance
    .get(ADMIN_USER_LIST(page, size, sf, so, text, levelid, levelval, usertype, role, from, till, domain, statusList, activefrom, activetill))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getGroupInfoAdmin = async () => {
  let response;
  await instance
    .get(ADMIN_GET_GROUP_INFO)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getRoutingLevelsAdmin = async () => {
  let response;
  await instance
    .get(ADMIN_GET_ROUTING_LEVELS)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getCurationRoutingAdminValues = async () => {
  let response;
  await instance
    .get(ADMIN_GET_CURATION_ROUTING_VALUES)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getCurationRoutingAdminValuesByGroups = async () => {
  let response;
  await instance
    .get(ADMIN_GET_CURATION_ROUTING_GROUP_WISE)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const updateCurationRoutingLevels = async (query) => {
  let response;
  await instance
    .post(ADMIN_UPDATE_ROUTING_LEVELS, query)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};


export const updateAdminGroupInfo = async (query) => {
  let response;
  await instance
    .post(ADMIN_UPDATE_GROUP_INFO, query)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const updateCurationPoint = async (query) => {
  let response;
  await instance
    .put(UPDATE_CURATION_ROUTING_POINT, query)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const generateGenAi = async (payload) => {
  let response;
  await instance
    .post(REGENERATE_GENAI, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const ActionLevelRestriction = async (callback) => {
  let response;
  await instance
    .get(`${Level_Action_Restriction}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res?.data?.data?.restrictions;
      store.dispatch(ActionLevel(res?.data?.data?.restrictions));

      if (callback) {
        callback(response);
      }
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const UpdateRestrictionPermission = async (payload) => {
  let response;
  await instance
    .post(UpdateRestriction, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      toast.success(submitRatingSuccessToast(res.data.message), {
        position: toast.POSITION.TOP_RIGHT,
      });
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const userActiveInactiveToggle = async (payload) => {
  let response;
  await instance
    .post(USER_INACTIVE_TOGGLE, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getRegionValue = async (value, geoLevelId) => {
  let response;
  await instance
    .get(getRegion(value, geoLevelId))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res?.data?.data;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const userInvitation = async (payload) => {
  let response;
  await instance
    .post(USER_INVITE_API, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};



export const userRemove = async (userUuid) => {
  let response;
  await instance
    .get(USER_REMOVE_FROM_GROUP(userUuid))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const fetchRoles = async () => {
  let response;
  await instance
    .get(FETCH_ROLES)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};



export const getAttrUser = async (id) => {
  let response;
  await instance
    .get(`${GET_USER_ATTR}${id}`)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const getTimeZones = async () => {
  // console.log("hello")
  let response;
  await instance
    .get(GET_TIMEZONES)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      let newData = [];
      res.data.data.filter((obj, ind) => {
        newData.push({ name: obj, label: obj, value: ind });
      });
      response = newData;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const configAttrUser = async (payload) => {
  let response;
  await instance
    .post(CONFIG_USER_ATTR, payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};
export const PermissionRole = async (payload, name) => {
  let response;
  await instance
    .post(updatePermission(name), payload)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      toast.success(submitRatingSuccessToast(res?.data?.message), {
        position: toast.POSITION.TOP_RIGHT,
      });
      response = res;
    })
    .catch((err) => {
      if (err?.response?.status == 500) {
        return toast.warn(
          submitRatingSuccessToast("This role already exists"),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      } else handleError(err);
    });
  return response;

  // const response = await fetch(EDIT_ROLE(name), {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   body: JSON.stringify(payload),
  // });
  // let response;
  // await instance
  //   .post(EDIT_ROLE(name), payload)
  //   .then((res) => {
  //     if (res === undefined) {
  //       return;
  //     }
  //     response = res;
  //   })
  //   .catch((err) => {
  //     console.log("error", err);
  //     if (err.response.status == 500) {
  //       return toast.warn(
  //         submitRatingSuccessToast("This role already exists"),
  //         {
  //           position: toast.POSITION.TOP_RIGHT,
  //         }
  //       );
  //     } else handleError(err);
  //   });
  // let response;
  // await fetch(BASE_URL + EDIT_ROLE(name), {
  //   method: "POST",
  //   credentials: "same-origin",
  //   headers: {
  //     Accept: "application/json",
  //     "Content-Type": "application/json",
  //     Cookie: document.cookie,
  //   },
  //   body: JSON.stringify(payload),
  // })
  //   .then((res) => res.json())
  //   .then((res1) => {
  //     // if (res1.status && res1.status === 401) {
  //     //   userLogout();
  //     // }
  //     response = res1;
  //   })
  //   .catch((err) => {
  //     console.log("error", err);
  // if (err?.response?.status == 500) {
  //   return toast.warn(
  //     submitRatingSuccessToast("This role already exists"),
  //     {
  //       position: toast.POSITION.TOP_RIGHT,
  //     }
  //   );
  // } else handleError(err);
  //   });
  // return response;
};




export const getEmailIntegration = async (page) => {
  let response;
  await instance
    .get(EmailIntegration(page))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getTicketData = async (ticketId) => {
  let response;
  await instance
    .get(Email_Thread_QA(ticketId))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      // console.log("response", res)
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};


export const updateQaEmailPair = async (payload) => {
  let response = [];
  await instance
    .post(updateDeleteEmailQaPair, payload)
    .then((res) => {
      if (res !== undefined) {
        // console.log("response", res)
        toast.success(
          submitRatingSuccessToast(res?.data?.message),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        response = res;

      }
    })
    .catch((err) => {
      handleError(err);
    });
  return response;

  // await fetch(BASE_URL + updateDeleteEmailQaPair, {
  //   method: "POST",
  //   credentials: "same-origin",
  //   headers: {
  //     Accept: "application/json",
  //     "Content-Type": "application/json",
  //     Cookie: document.cookie,
  //   },
  //   body: JSON.stringify(payload),
  // })
  //   .then((res) => res.json())
  //   .then((res1) => {
  //     // if (res1.status && res1.status === 401) {
  //     //   userLogout();
  //     // }
  //     response = res1;
  //   })
  //   .catch((err) => {
  //     handleError(err);
  //   });
  // return response;
};

export const deleteQaPair = async (emailId) => {
  const payload = {
    "action": "delete",
    "qaPairs": [
      {
        "id": emailId
      }
    ]
  };
  let response;

  await instance.post(updateDeleteEmailQaPair, payload).then((res) => {
    if (res === undefined) return
    if (res !== undefined) {

      response = res.data.data;
      toast.success(
        submitRatingSuccessToast(res?.data?.message),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );

    }
  }).catch((err) => {
    handleError(err);
  });
  return response
}

export const updatePublishApi = async (emailId, publishment) => {
  const payload = {
    "action": publishment,
    "qaPairs": [
      {
        "id": emailId
      }
    ]
  };
  let response;

  await instance.post(updateDeleteEmailQaPair, payload).then((res) => {
    if (res === undefined) return
    if (res !== undefined) {
      // console.log("responsed dta", res);
      toast.success(
        submitRatingSuccessToast(res?.data?.message),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      response = res;

    }
  }).catch((err) => {
    handleError(err);
  });
  return response
}

export const updateEmailAccess = async (ticketUuidStr, usageAccess) => {
  const payload = {
    ticketUuidStr, usageAccess
  };
  let response;

  await instance.post(updateDeleteEmailQaPair, payload).then((res) => {
    if (res === undefined) return
    if (res !== undefined) {

      toast.success(
        submitRatingSuccessToast(res?.data?.message),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      response = res;

    }
  }).catch((err) => {
    handleError(err);
  });
  return response
}
export const seekerPagesApi = async (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  status
) => {
  let response;
  let answerUuids = [];
  let docIds = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.toString();
  }
  await instance
    .get(PAGES_API(pageNo, sortFilter, sortOrder, sortChange, domains, status))
    .then((res) => {
      if (res === undefined) {
        return;
      }
      getKeyTag(res.data.data.map(td => td.questionUuid))
      res.data.data.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            answer.threadAttachments.unshift([]);
            answer.threadAttachments.unshift([]);
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          userUuid.push(answer.expertUuid);
          answer.answerCopy = answer.answer;
          if (answer.docId === undefined) {
            answerUuids.push(
              answer.originalAnswerUuid !== undefined
                ? answer.originalAnswerUuid
                : answer.answerUuid
            );
          } else {
            docIds.push(answer.docId);
          }
          answer.attachmentURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachmentsURL = [];
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    // console.log('payload5', payload)
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                      let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;
                      answer.answer = answer.answer.replaceAll(
                        replacedContent,
                        imgTag
                      );
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                      // store.dispatch(getTrendingQA(res.data.data));
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              // console.log('payload4', payload)
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, docIds, undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getTabSearchData2 = async (
  pageNo,
  status,
  sortFilter,
  question,
  sortOrder,
  sortChange,
  domains,
  category = null,
) => {
  let response;
  let answerUuids = [];
  let allInlineImages = [];
  let userUuid = [];
  if (domains.length > 0) {
    domains = domains.toString();
  }
  // `/question/group/${currentGroup}/tab-search?category=${category}&solarIndex=0&question=${question}&page=${page}&status=${status}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
  //   domainFilter
  // )}`
  let paylaod = {
    category: category,
    solarIndex: 0,
    question: question,
    page: pageNo,
    status: status,
    sortFilter: sortFilter,
    sortOrder: sortOrder,
    sortChange: sortChange,
    domain: encodeURIComponent(domains),
  };
  await instance
    .post(TAB_SEARCH, paylaod)
    .then((res) => {
      if (res === undefined) {
        return;
      }
      res.data.data.filter((qa) => {
        qa.answersList.filter((answer) => {
          if (qa.reusableThreadQA) {
            answer.threadAttachments.unshift([]);
            answer.threadAttachments.unshift([]);
          }
          if (
            answer.expertUuid != getDataFromCookies("userUuid") &&
            answer.seekerCurationVisibility &&
            answer.curationCategory == "1" &&
            answer.curationStatus == "pending"
          ) {
            qa.isShowUpdateRequestWarning = true;
          }
          userUuid.push(answer.expertUuid);
          answer.answerCopy = answer.answer;
          answerUuids.push(
            answer.originalAnswerUuid !== undefined
              ? answer.originalAnswerUuid
              : answer.answerUuid
          );
          answer.attachmentURL = [];
          answer.threadAttachmentsURL = [];
          if (answer.answer.includes("vizsep")) {
            answer.threadAttachments.filter((att1) => {
              if (att1.length === 0) {
                answer.threadAttachmentsURL.push([]);
              } else {
                let asdffgh = [];
                att1.filter((att2) => {
                  if (
                    att2.name.includes(".jpeg") ||
                    att2.name.includes(".jpg") ||
                    att2.name.includes(".png") ||
                    att2.name.includes(".JPEG") ||
                    att2.name.includes(".JPG") ||
                    att2.name.includes(".PNG")
                  ) {
                    let payload = { name: att2.name };
                    // console.log('payload3', payload)
                    instance
                      .post(GET_IMAGE_ATTACHMENT_URL, payload)
                      .then((res1) => {
                        if (res1 === undefined) {
                          return;
                        }
                        asdffgh.push(res1.data.data);
                        store.dispatch(refreshTrendingData("refreshed"));
                      })
                      .catch((err) => {
                        handleError(err);
                      });
                  }
                });
                answer.threadAttachmentsURL.push(asdffgh);
              }
            });
          }
          if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            allInlineImages = allInlineImages.concat(answer.inlineImages);
            instance
              .post(GET_FILES, answer.inlineImages)
              .then((res1) => {
                if (res1 === undefined) {
                  return;
                }
                if (res1.data.success) {
                  for (let i = 0; i < answer.inlineImages.length; ++i) {
                    if (answer.inlineImages[i].includes(".png")) {
                      let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;
                      answer.answer = answer.answer.replaceAll(
                        replacedContent,
                        imgTag
                      );
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
                        }></img>`;

                      let replacedContent = answer.inlineImages[i];
                      answer.answer = answer.answer.replace(
                        replacedContent,
                        imgTag
                      );
                    }
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          answer.attachments.filter((attch) => {
            if (
              attch.name.includes(".png") ||
              attch.name.includes(".jpg") ||
              attch.name.includes(".jpeg") ||
              attch.name.includes(".JPEG") ||
              attch.name.includes(".JPG") ||
              attch.name.includes(".PNG")
            ) {
              let payload = { name: attch.name };
              console.log('payload2', payload)
              instance
                .post(GET_IMAGE_ATTACHMENT_URL, payload)
                .then((res1) => {
                  if (res1 === undefined) {
                    return;
                  }
                  answer.attachmentURL.push(res1.data.data);
                  store.dispatch(refreshTrendingData("refreshed"));
                })
                .catch((err) => {
                  handleError(err);
                });
            }
          });
        });
      });
      getFiles([...new Set(allInlineImages)]);
      getAnswerRatings(answerUuids, [], undefined);
      getExpertsProfilePics(userUuid, undefined);
      response = res;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const newTrendingAPITwo = async (page, sortData, domains, ei, ti, si, vi, ai, text) => {
  let payload = {
    page: page,
    sort: sortData.valueOrig,
    order: sortData.sortOrder,
    domains: domains.toString(),
    expertIndex: ei,
    threadIndex: ti,
    searchIndex: si,
    viewIndex: vi,
    acceptedIndex: ai,
    searchText: text
  }
  let response;
  let questionUuid = []
  let answerUuids = [];
  let userUuid = [];
  let docIds = [];
  let keyTagsId = [];
  await instance.post(NEW_TRENDING_API_TWO, payload).then(res => {
    res.data.data.records.filter(qa => {
      if (qa.answersList === undefined) {
        if (qa.soId === undefined) {
          questionUuid.push(qa.questionUuid);
        } else {
          questionUuid.push(qa.soId);
        }
      }
      keyTagsId.push(qa.questionUuid);
    })
    getKeyTag(keyTagsId);
    const chunkSize = Math.ceil(questionUuid.length / 3);
    Promise.all([
      getDetailedrecord("", questionUuid.slice(0, chunkSize), true).then(res1 => {
        res.data.data.records.filter(qa => {
          if (qa.answersList === undefined) {
            if (qa.soId === undefined) {
              qa.answersList = res1.data.data[qa.questionUuid];
            } else {
              qa.answersList = res1.data.data[qa.soId];
            }
          }
          qa.answersList !== undefined && qa.answersList.filter((answer) => {
            if (qa.reusableThreadQA) {
              if (qa.status === "accepted") {
                answer.threadAttachments.unshift([]);
                answer.threadAttachments.unshift([]);
              }
              if (qa.status !== "accepted") {
                answer.threadAttachments.filter((arr2) => {
                  if (arr2.length > 0) {
                    arr2.filter((obj) => {
                      answer.attachments.push(obj);
                    });
                  }
                });
              }
            }
            if (
              answer.expertUuid != getDataFromCookies("userUuid") &&
              answer.seekerCurationVisibility &&
              answer.curationCategory == "1" &&
              answer.curationStatus == "pending"
            ) {
              qa.isShowUpdateRequestWarning = true;
            }
            if (answer.expertUuid !== undefined) {
              userUuid.push(answer.expertUuid);
            }
            answer.answerCopy = answer.answer;
            if (answer.docId === undefined) {
              if (answer.answerUuid !== undefined) {
                answerUuids.push(
                  answer.originalAnswerUuid !== undefined
                    ? answer.originalAnswerUuid
                    : answer.answerUuid
                );
              }
            } else {
              docIds.push(answer.docId);
            }
            answer.attachmentURL = [];
            if (answer.answer.includes("vizsep")) {
              answer.threadAttachmentsURL = [];
              answer.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  answer.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png") ||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      instance
                        .post(GET_IMAGE_ATTACHMENT_URL, payload)
                        .then((res1) => {
                          if (res1 === undefined) {
                            return;
                          }
                          asdffgh.push(res1.data.data);
                          store.dispatch(refreshTrendingData("refreshed"));
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  answer.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            // if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            //   // allInlineImages = allInlineImages.concat(answer.inlineImages);
            //   instance
            //     .post(GET_FILES, answer.inlineImages)
            //     .then((res1) => {
            //       if (res1 === undefined) {
            //         return;
            //       }
            //       if (res1.data.success) {
            //         for (let i = 0; i < answer.inlineImages.length; ++i) {
            //           if (answer.inlineImages[i].includes(".png")) {
            //           } else {
            //             let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
            //               }></img>`;

            //             let replacedContent = answer.inlineImages[i];
            //             answer.answer = answer.answer.replaceAll(
            //               replacedContent,
            //               imgTag
            //             );
            //             // store.dispatch(getTrendingQA(res.data.data));
            //           }
            //         }
            //       }
            //     })
            //     .catch((err) => {
            //       console.log(err);
            //     });
            // }
            answer.attachments.filter((attch) => {
              if (
                attch.name.toLowerCase().includes(".png") ||
                attch.name.toLowerCase().includes(".jpg") ||
                attch.name.toLowerCase().includes(".jpeg") ||
                attch.name.toLowerCase().includes(".JPEG") ||
                attch.name.toLowerCase().includes(".JPG") ||
                attch.name.toLowerCase().includes(".PNG")
              ) {
                let payload = { name: attch.name };
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    answer.attachmentURL.push(res1.data.data);
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              if (
                attch.name.toLowerCase().includes(".mov") ||
                attch.name.toLowerCase().includes(".mp4") ||
                attch.name.toLowerCase().includes(".mkv")
              ) {
                let payload = [attch.name];
                instance
                  .post(GET_FILES, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    attch.objectUrl = res1.data.data[attch.name];
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              // console.log(answer.attachments)
            });
          });
        })
        store.dispatch(getTrendingQA(res.data.data.records));
        // console.log("hello")
       
        // updateRatingBoolean
        getAnswerRatings(answerUuids, docIds, undefined);
        getExpertsProfilePics(userUuid, undefined);
        updateViewCountTwo({ answerIds: answerUuids, docIds: docIds });
      }),
      getDetailedrecord("", questionUuid.slice(chunkSize, chunkSize * 2), true).then(res1 => {
        res.data.data.records.filter(qa => {
          if (qa.answersList === undefined) {
            if (qa.soId === undefined) {
              qa.answersList = res1.data.data[qa.questionUuid];
            } else {
              qa.answersList = res1.data.data[qa.soId];
            }
          }
          qa.answersList !== undefined && qa.answersList.filter((answer) => {
            if (qa.reusableThreadQA) {
              if (qa.status === "accepted") {
                answer.threadAttachments.unshift([]);
                answer.threadAttachments.unshift([]);
              }
              if (qa.status !== "accepted") {
                answer.threadAttachments.filter((arr2) => {
                  if (arr2.length > 0) {
                    arr2.filter((obj) => {
                      answer.attachments.push(obj);
                    });
                  }
                });
              }
            }
            if (
              answer.expertUuid != getDataFromCookies("userUuid") &&
              answer.seekerCurationVisibility &&
              answer.curationCategory == "1" &&
              answer.curationStatus == "pending"
            ) {
              qa.isShowUpdateRequestWarning = true;
            }
            if (answer.expertUuid !== undefined) {
              userUuid.push(answer.expertUuid);
            }
            answer.answerCopy = answer.answer;
            if (answer.docId === undefined) {
              if (answer.answerUuid !== undefined) {
                answerUuids.push(
                  answer.originalAnswerUuid !== undefined
                    ? answer.originalAnswerUuid
                    : answer.answerUuid
                );
              }
            } else {
              docIds.push(answer.docId);
            }
            answer.attachmentURL = [];
            if (answer.answer.includes("vizsep")) {
              answer.threadAttachmentsURL = [];
              answer.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  answer.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png") ||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      instance
                        .post(GET_IMAGE_ATTACHMENT_URL, payload)
                        .then((res1) => {
                          if (res1 === undefined) {
                            return;
                          }
                          asdffgh.push(res1.data.data);
                          store.dispatch(refreshTrendingData("refreshed"));
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  answer.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            // if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            //   // allInlineImages = allInlineImages.concat(answer.inlineImages);
            //   instance
            //     .post(GET_FILES, answer.inlineImages)
            //     .then((res1) => {
            //       if (res1 === undefined) {
            //         return;
            //       }
            //       if (res1.data.success) {
            //         for (let i = 0; i < answer.inlineImages.length; ++i) {
            //           if (answer.inlineImages[i].includes(".png")) {
            //           } else {
            //             let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
            //               }></img>`;

            //             let replacedContent = answer.inlineImages[i];
            //             answer.answer = answer.answer.replaceAll(
            //               replacedContent,
            //               imgTag
            //             );
            //             // store.dispatch(getTrendingQA(res.data.data));
            //           }
            //         }
            //       }
            //     })
            //     .catch((err) => {
            //       console.log(err);
            //     });
            // }
            answer.attachments.filter((attch) => {
              if (
                attch.name.toLowerCase().includes(".png") ||
                attch.name.toLowerCase().includes(".jpg") ||
                attch.name.toLowerCase().includes(".jpeg") ||
                attch.name.toLowerCase().includes(".JPEG") ||
                attch.name.toLowerCase().includes(".JPG") ||
                attch.name.toLowerCase().includes(".PNG")
              ) {
                let payload = { name: attch.name };
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    answer.attachmentURL.push(res1.data.data);
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              if (
                attch.name.toLowerCase().includes(".mov") ||
                attch.name.toLowerCase().includes(".mp4") ||
                attch.name.toLowerCase().includes(".mkv")
              ) {
                let payload = [attch.name];
                instance
                  .post(GET_FILES, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    attch.objectUrl = res1.data.data[attch.name];
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              // console.log(answer.attachments)
            });
          });
        })
        store.dispatch(getTrendingQA(res.data.data.records));
        // console.log("hello")
        getAnswerRatings(answerUuids, docIds, undefined);
        getExpertsProfilePics(userUuid, undefined);
        updateViewCountTwo({ answerIds: answerUuids, docIds: docIds });
      }),
      getDetailedrecord("", questionUuid.slice(chunkSize * 2), true).then(res1 => {
        res.data.data.records.filter(qa => {
          if (qa.answersList === undefined) {
            if (qa.soId === undefined) {
              qa.answersList = res1.data.data[qa.questionUuid];
            } else {
              qa.answersList = res1.data.data[qa.soId];
            }
          }
          qa.answersList !== undefined && qa.answersList.filter((answer) => {
            if (qa.reusableThreadQA) {
              if (qa.status === "accepted") {
                answer.threadAttachments.unshift([]);
                answer.threadAttachments.unshift([]);
              }
              if (qa.status !== "accepted") {
                answer.threadAttachments.filter((arr2) => {
                  if (arr2.length > 0) {
                    arr2.filter((obj) => {
                      answer.attachments.push(obj);
                    });
                  }
                });
              }
            }
            if (
              answer.expertUuid != getDataFromCookies("userUuid") &&
              answer.seekerCurationVisibility &&
              answer.curationCategory == "1" &&
              answer.curationStatus == "pending"
            ) {
              qa.isShowUpdateRequestWarning = true;
            }
            if (answer.expertUuid !== undefined) {
              userUuid.push(answer.expertUuid);
            }
            answer.answerCopy = answer.answer;
            if (answer.docId === undefined) {
              if (answer.answerUuid !== undefined) {
                answerUuids.push(
                  answer.originalAnswerUuid !== undefined
                    ? answer.originalAnswerUuid
                    : answer.answerUuid
                );
              }
            } else {
              docIds.push(answer.docId);
            }
            answer.attachmentURL = [];
            if (answer.answer.includes("vizsep")) {
              answer.threadAttachmentsURL = [];
              answer.threadAttachments.filter((att1) => {
                if (att1.length === 0) {
                  answer.threadAttachmentsURL.push([]);
                } else {
                  let asdffgh = [];
                  att1.filter((att2) => {
                    if (
                      att2.name.includes(".jpeg") ||
                      att2.name.includes(".jpg") ||
                      att2.name.includes(".png") ||
                      att2.name.includes(".JPEG") ||
                      att2.name.includes(".JPG") ||
                      att2.name.includes(".PNG")
                    ) {
                      let payload = { name: att2.name };
                      instance
                        .post(GET_IMAGE_ATTACHMENT_URL, payload)
                        .then((res1) => {
                          if (res1 === undefined) {
                            return;
                          }
                          asdffgh.push(res1.data.data);
                          store.dispatch(refreshTrendingData("refreshed"));
                        })
                        .catch((err) => {
                          handleError(err);
                        });
                    }
                  });
                  answer.threadAttachmentsURL.push(asdffgh);
                }
              });
            }
            // if (answer.inlineImages !== null && answer.inlineImages.length > 0) {
            //   // allInlineImages = allInlineImages.concat(answer.inlineImages);
            //   instance
            //     .post(GET_FILES, answer.inlineImages)
            //     .then((res1) => {
            //       if (res1 === undefined) {
            //         return;
            //       }
            //       if (res1.data.success) {
            //         for (let i = 0; i < answer.inlineImages.length; ++i) {
            //           if (answer.inlineImages[i].includes(".png")) {
            //             let replacedContent = `[content|${answer.inlineImages[i].split(".")[0]
            //               }|]`;
            //             let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
            //               }></img>`;
            //             answer.answer = answer.answer.replaceAll(
            //               replacedContent,
            //               imgTag
            //             );

            //           } else {
            //             let imgTag = `<img style='max-width:50%' src=${res1.data.data[answer.inlineImages[i]]
            //               }></img>`;

            //             let replacedContent = answer.inlineImages[i];
            //             answer.answer = answer.answer.replaceAll(
            //               replacedContent,
            //               imgTag
            //             );
            //             // store.dispatch(getTrendingQA(res.data.data));
            //           }
            //         }
            //       }
            //     })
            //     .catch((err) => {
            //       console.log(err);
            //     });
            // }
            answer.attachments.filter((attch) => {
              if (
                attch.name.toLowerCase().includes(".png") ||
                attch.name.toLowerCase().includes(".jpg") ||
                attch.name.toLowerCase().includes(".jpeg") ||
                attch.name.toLowerCase().includes(".JPEG") ||
                attch.name.toLowerCase().includes(".JPG") ||
                attch.name.toLowerCase().includes(".PNG")
              ) {
                let payload = { name: attch.name };
                instance
                  .post(GET_IMAGE_ATTACHMENT_URL, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    answer.attachmentURL.push(res1.data.data);
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              if (
                attch.name.toLowerCase().includes(".mov") ||
                attch.name.toLowerCase().includes(".mp4") ||
                attch.name.toLowerCase().includes(".mkv")
              ) {
                let payload = [attch.name];
                instance
                  .post(GET_FILES, payload)
                  .then((res1) => {
                    if (res1 === undefined) {
                      return;
                    }
                    attch.objectUrl = res1.data.data[attch.name];
                    store.dispatch(refreshTrendingData("refreshed"));
                  })
                  .catch((err) => {
                    handleError(err);
                  });
              }
              // console.log(answer.attachments)
            });
          });
        })
        store.dispatch(getTrendingQA(res.data.data.records));
        // console.log("hello")
        getAnswerRatings(answerUuids, docIds, undefined);
        getExpertsProfilePics(userUuid, undefined);
        updateViewCountTwo({ answerIds: answerUuids, docIds: docIds });
      })
    ])

    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const getKeyTag = (ids) => {
  instance.post(GET_KEY_TAGS, { questionIds: ids }).then(res => {
    // console.log("res",res)
    store.dispatch(updateKeytagsData(res.data.data))
    store.dispatch(getTagsInOpen(res.data.data))
    store.dispatch(getTagsInExpertOpen(res.data.data))
    store.dispatch(getExpertRecordKeyTag(res.data.data))
    store.dispatch(getSearchSuggestionKeytag(res.data.data))
    
    // getSearchSuggestionKeytag
    // getExpertRecordKeyTag
  }).catch(err => {
    handleError(err);
  })
}

export const getBriefPlanning = async (payload) => {
  let response;
  await instance.post(GET_AGENT_PLANNING, payload).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const saveBriefs = async (id) => {
  let response;
  await instance.put(`${SAVE_AGENT_BRIEF}agenticid=${id}`).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const getBriefHistory = async (cmview,page) => {
  let response;
  await instance.get(`${AGENT_BRIEF_HISTORY}cmview=${cmview}&page=${page}`).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const getBriefHistoryCount = async (cmview) => {
  let response;
  await instance.get(`${AGENT_BRIEF_HISTORY}count=true&cmview=${cmview}`).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const getExternalSearch = (payload) => {
  let response;
  instance.post(GET_EXTERNAL_LINK_DATA, payload).then(res => {
    store.dispatch(searchDataLoading(false))
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const deleteBriefHistory = async (id) => {
  let response;
  await instance.delete(`${AGENT_BRIEF_DELETE}agenticid=${id}`).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const getTicketRecords = async (pageNo, status, category, sort, search, assignee, subject, ticketId, emailBody, from) => { 
  let response;
  await instance.get(GET_TICKET_RECORDS(pageNo, status, category, sort, search, assignee, subject, ticketId, emailBody, from)).then(res => {
       response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const getAppStatus = async () => {
  let response;
  await instance.get(APP_STATUS).then(res => {
       response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
 

export const getTicketDetails = async (id) => {
  let response;
  await instance.get(`${TICKET_DETAIL(id)}`).then(res => {
        response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const getIncident = async (date,type) => {
  let response;
  await instance.post(`${INCIDENT}date=${date}&service=${type}`).then(res => {
        response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}


export const ticketReadUnread = async (payload) => {
  let response;
  await fetch(BASE_URL + TICKET_UNREAD_READ, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Cookie: document.cookie,
    },
    body: payload,
  })
    .then((res) => res.json())
    .then((res1) => {
      // if (res1.status && res1.status === 401) {
      //   userLogout();
      // }
      response = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const ticketReadUnread2 = async (payload) => {
  let response;
  await fetch(BASE_URL + TICKET_UNREAD_READ_2, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Cookie: document.cookie,
    },
    body: payload,
  })
    .then((res) => res.json())
    .then((res1) => {
      // if (res1.status && res1.status === 401) {
      //   userLogout();
      // }
      response = res1;
    })
    .catch((err) => {
      handleError(err);
    });
  return response;
};

export const getCategoryExperts = async () => {
  let response;
  await instance.get(CATEGORY_EXPERT).then(res => {
    response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const assigncategories = async (payload) => {
  let response;
  await instance.post(TICKET_ASSIGN, payload).then(res => {
       response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
export const createIncidentAPI = async (payload) => {
  console.log("payload", payload)
  let response;
  await instance.post(CREATE_INCIDENT, payload).then(res => {
        response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}
 
export const emailActionCall = async (payload) => {
  let response;
  await instance.post(EMAIL_ACTION, payload).then(res => {
        response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}

export const openAPiSingleData = async (id) => {
  let response;
  await instance.get(`${EXPERT_OPEN_QUESTION}questionId=${id}`).then(res => {
        response = res;
  }).catch(err => {
    handleError(err);
  })
  return response;
}